// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/datagateway/v1/delivery_sds.proto (package mono.datagateway.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";
import { ReviewStatement } from "../../common/v1/types_pb";
/**
 * BidBaseline — frozen snapshot of a submitted proposal. Created by
 * ConvertProposalToPreAward (zou orchestration handler). Immutable after
 * freeze; reopen requires a new version row.
 *
 * @generated from message mono.datagateway.v1.BidBaseline
 */ export class BidBaseline extends Message {
    static fromBinary(bytes, options) {
        return new BidBaseline().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BidBaseline().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BidBaseline().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BidBaseline, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string proposal_project_id = 3;
   */ _define_property(this, "proposalProjectId", ""), /**
   * @generated from field: int32 version = 4;
   */ _define_property(this, "version", 0), /**
   * @generated from field: google.protobuf.Timestamp frozen_at = 5;
   */ _define_property(this, "frozenAt", void 0), /**
   * @generated from field: string frozen_by = 6;
   */ _define_property(this, "frozenBy", ""), /**
   * @generated from field: string technical_commitments_json = 7;
   */ _define_property(this, "technicalCommitmentsJson", ""), /**
   * @generated from field: string staffing_plan_json = 8;
   */ _define_property(this, "staffingPlanJson", ""), /**
   * @generated from field: string pricing_baseline_json = 9;
   */ _define_property(this, "pricingBaselineJson", ""), /**
   * JSON []{clin, pws, title, due_date, cadence, ...}
   *
   * @generated from field: string planned_deliverables_json = 10;
   */ _define_property(this, "plannedDeliverablesJson", ""), /**
   * @generated from field: string assumptions_json = 11;
   */ _define_property(this, "assumptionsJson", ""), /**
   * @generated from field: repeated string source_artifact_ids = 12;
   */ _define_property(this, "sourceArtifactIds", []), /**
   * @generated from field: google.protobuf.Timestamp created_at = 13;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: string submission_id = 14;
   */ _define_property(this, "submissionId", ""), /**
   * @generated from field: string pre_award_project_id = 15;
   */ _define_property(this, "preAwardProjectId", ""), /**
   * Exact authoritative PROP-14 snapshot, including file versions and locators.
   *
   * @generated from field: string submission_snapshot_json = 16;
   */ _define_property(this, "submissionSnapshotJson", ""), /**
   * @generated from field: string pricing_version_id = 17;
   */ _define_property(this, "pricingVersionId", ""), /**
   * @generated from field: string staffing_version_id = 18;
   */ _define_property(this, "staffingVersionId", ""), /**
   * @generated from field: string solicitation_version_id = 19;
   */ _define_property(this, "solicitationVersionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(BidBaseline, "runtime", proto3);
_define_property(BidBaseline, "typeName", "mono.datagateway.v1.BidBaseline");
_define_property(BidBaseline, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "proposal_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "frozen_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "frozen_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "technical_commitments_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "staffing_plan_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "pricing_baseline_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "planned_deliverables_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "assumptions_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "source_artifact_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 13,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 14,
            name: "submission_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "pre_award_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "submission_snapshot_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "pricing_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "staffing_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "solicitation_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * PreAwardProject — pre-award workspace metadata. The Project workspace row
 * itself (id, name, members, etc.) stays in zou; this row carries the
 * SDS-specific state and links back to the proposal + baseline.
 *
 * @generated from message mono.datagateway.v1.PreAwardProject
 */ export class PreAwardProject extends Message {
    static fromBinary(bytes, options) {
        return new PreAwardProject().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PreAwardProject().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PreAwardProject().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PreAwardProject, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string proposal_project_id = 3;
   */ _define_property(this, "proposalProjectId", ""), /**
   * @generated from field: string bid_baseline_id = 4;
   */ _define_property(this, "bidBaselineId", ""), /**
   * FK to zou.Project (type=PRE_AWARD)
   *
   * @generated from field: string zou_project_id = 5;
   */ _define_property(this, "zouProjectId", ""), /**
   * Draft | InProgress | ReadyForAward | Converted | Archived
   *
   * @generated from field: string state = 6;
   */ _define_property(this, "state", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: string created_by = 8;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 9;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 10;
   */ _define_property(this, "deletedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PreAwardProject, "runtime", proto3);
_define_property(PreAwardProject, "typeName", "mono.datagateway.v1.PreAwardProject");
_define_property(PreAwardProject, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "proposal_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "bid_baseline_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "zou_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "deleted_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * ReadinessPackage — one row per (pre_award, area). 8 areas per SDS §3.3.
 *
 * @generated from message mono.datagateway.v1.ReadinessPackage
 */ export class ReadinessPackage extends Message {
    static fromBinary(bytes, options) {
        return new ReadinessPackage().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReadinessPackage().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReadinessPackage().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReadinessPackage, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string pre_award_project_id = 3;
   */ _define_property(this, "preAwardProjectId", ""), /**
   * Staffing|Financial|Subcontractor|Schedule|Governance|Customer|Artifacts|Risk
   *
   * @generated from field: string area = 4;
   */ _define_property(this, "area", ""), /**
   * NotStarted|InProgress|Ready|Blocked
   *
   * @generated from field: string status = 5;
   */ _define_property(this, "status", ""), /**
   * area-specific shape, validated app-side
   *
   * @generated from field: string data_json = 6;
   */ _define_property(this, "dataJson", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 8;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: string updated_by = 9;
   */ _define_property(this, "updatedBy", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReadinessPackage, "runtime", proto3);
_define_property(ReadinessPackage, "typeName", "mono.datagateway.v1.ReadinessPackage");
_define_property(ReadinessPackage, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "pre_award_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "area",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "data_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "updated_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * FieldLineage — per-field provenance. Every contract-project field that
 * participates in the lifecycle has its current value in canonical tables
 * AND a row here with the source kind + artifact. Modifications append new
 * rows with source_kind=Modification.
 *
 * @generated from message mono.datagateway.v1.FieldLineage
 */ export class FieldLineage extends Message {
    static fromBinary(bytes, options) {
        return new FieldLineage().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FieldLineage().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FieldLineage().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FieldLineage, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string target_object_type = 3;
   */ _define_property(this, "targetObjectType", ""), /**
   * @generated from field: string target_object_id = 4;
   */ _define_property(this, "targetObjectId", ""), /**
   * @generated from field: string target_field_path = 5;
   */ _define_property(this, "targetFieldPath", ""), /**
   * ProposalBaseline|PreAward|FinalContract|AwardComparison|Modification|Manual
   *
   * @generated from field: string source_kind = 6;
   */ _define_property(this, "sourceKind", ""), /**
   * @generated from field: string source_artifact_id = 7;
   */ _define_property(this, "sourceArtifactId", ""), /**
   * @generated from field: string source_change_set_id = 8;
   */ _define_property(this, "sourceChangeSetId", ""), /**
   * @generated from field: string source_modification_id = 9;
   */ _define_property(this, "sourceModificationId", ""), /**
   * @generated from field: string value_json = 10;
   */ _define_property(this, "valueJson", ""), /**
   * @generated from field: google.protobuf.Timestamp written_at = 11;
   */ _define_property(this, "writtenAt", void 0), /**
   * @generated from field: string written_by = 12;
   */ _define_property(this, "writtenBy", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(FieldLineage, "runtime", proto3);
_define_property(FieldLineage, "typeName", "mono.datagateway.v1.FieldLineage");
_define_property(FieldLineage, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "target_object_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "target_object_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "target_field_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "source_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "source_artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "source_change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "source_modification_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "value_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "written_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "written_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ContractActivationGate — one row per contract project. Seeded with 15
 * items (see ContractActivationGateItem). Activation requires all items in
 * {Complete, Waived}.
 *
 * @generated from message mono.datagateway.v1.ContractActivationGate
 */ export class ContractActivationGate extends Message {
    static fromBinary(bytes, options) {
        return new ContractActivationGate().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractActivationGate().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractActivationGate().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractActivationGate, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * FK to zou.Project / pangaea.Program
   *
   * @generated from field: string contract_project_id = 3;
   */ _define_property(this, "contractProjectId", ""), /**
   * Pending|Activated|Closed
   *
   * @generated from field: string state = 4;
   */ _define_property(this, "state", ""), /**
   * @generated from field: google.protobuf.Timestamp activated_at = 5;
   */ _define_property(this, "activatedAt", void 0), /**
   * @generated from field: string activated_by = 6;
   */ _define_property(this, "activatedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 8;
   */ _define_property(this, "updatedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractActivationGate, "runtime", proto3);
_define_property(ContractActivationGate, "typeName", "mono.datagateway.v1.ContractActivationGate");
_define_property(ContractActivationGate, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "contract_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "activated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "activated_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * ContractActivationGateItem — 15 rows seeded per gate. Per SDS §4.4.
 * item_key enum:
 *   FinalContractAttached | PwsAttached | BidBaselineLinked | PreAwardLinked
 * | ComparisonCompleted | BlockingDiscrepanciesResolved | PmAssigned
 * | DesigneeAssigned | ContractsReadiness | FinanceReadiness
 * | SubkAtpReadiness | StaffingOnboardingReviewed | InitialDeliverableSchedule
 * | InitialCustomerPocs | KickoffPmpOnboardingArtifacts
 *
 * @generated from message mono.datagateway.v1.ContractActivationGateItem
 */ export class ContractActivationGateItem extends Message {
    static fromBinary(bytes, options) {
        return new ContractActivationGateItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractActivationGateItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractActivationGateItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractActivationGateItem, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string gate_id = 3;
   */ _define_property(this, "gateId", ""), /**
   * @generated from field: string item_key = 4;
   */ _define_property(this, "itemKey", ""), /**
   * Pending|Complete|Waived
   *
   * @generated from field: string state = 5;
   */ _define_property(this, "state", ""), /**
   * @generated from field: string reason = 6;
   */ _define_property(this, "reason", ""), /**
   * @generated from field: string decided_by = 7;
   */ _define_property(this, "decidedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp decided_at = 8;
   */ _define_property(this, "decidedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 10;
   */ _define_property(this, "updatedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractActivationGateItem, "runtime", proto3);
_define_property(ContractActivationGateItem, "typeName", "mono.datagateway.v1.ContractActivationGateItem");
_define_property(ContractActivationGateItem, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "gate_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "item_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "decided_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "decided_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * DeliverableEvidence — proof-of-delivery wrapper attached to a ProgramTask
 * (which is the SDS Deliverable). Without one of (artifact + POD) or
 * (external_ref + POD) or approved exception, the close-with-evidence
 * invariant rejects task closure.
 *
 * @generated from message mono.datagateway.v1.DeliverableEvidence
 */ export class DeliverableEvidence extends Message {
    static fromBinary(bytes, options) {
        return new DeliverableEvidence().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeliverableEvidence().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeliverableEvidence().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeliverableEvidence, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * FK to delivery.program_tasks (the deliverable)
   *
   * @generated from field: string program_task_id = 3;
   */ _define_property(this, "programTaskId", ""), /**
   * Artifact | ExternalReference
   *
   * @generated from field: string evidence_type = 4;
   */ _define_property(this, "evidenceType", ""), /**
   * FK pangaea Artifact (nullable)
   *
   * @generated from field: string artifact_id = 5;
   */ _define_property(this, "artifactId", ""), /**
   * FK ExternalArtifactReference (nullable)
   *
   * @generated from field: string external_reference_id = 6;
   */ _define_property(this, "externalReferenceId", ""), /**
   * @generated from field: google.protobuf.Timestamp delivery_timestamp = 7;
   */ _define_property(this, "deliveryTimestamp", void 0), /**
   * @generated from field: string submitted_by_user_id = 8;
   */ _define_property(this, "submittedByUserId", ""), /**
   * @generated from field: repeated string submitted_to_emails = 9;
   */ _define_property(this, "submittedToEmails", []), /**
   * @generated from field: string source_system = 10;
   */ _define_property(this, "sourceSystem", ""), /**
   * @generated from field: string proof_method = 11;
   */ _define_property(this, "proofMethod", ""), /**
   * @generated from field: bool screenshot_attached = 12;
   */ _define_property(this, "screenshotAttached", false), /**
   * @generated from field: bool email_file_attached = 13;
   */ _define_property(this, "emailFileAttached", false), /**
   * @generated from field: bool customer_receipt_attached = 14;
   */ _define_property(this, "customerReceiptAttached", false), /**
   * Pending|Validated|Rejected
   *
   * @generated from field: string validation_state = 15;
   */ _define_property(this, "validationState", ""), /**
   * @generated from field: string validated_by = 16;
   */ _define_property(this, "validatedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp validated_at = 17;
   */ _define_property(this, "validatedAt", void 0), /**
   * @generated from field: string exception_reason = 18;
   */ _define_property(this, "exceptionReason", ""), /**
   * @generated from field: string audit_event_id = 19;
   */ _define_property(this, "auditEventId", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 20;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 21;
   */ _define_property(this, "updatedAt", void 0), /**
   * The four dates that a Proof-of-Delivery review keeps distinct from
   * delivery_timestamp (which is unchanged): what the PM claimed, what was
   * extracted from the proof, and what a human accepted as operational, plus
   * the verification state comparing them. Unset (NULL) means "not yet
   * evaluated" for every one of these — see migration 000131.
   *
   * @generated from field: google.protobuf.Timestamp claimed_delivery_timestamp = 22;
   */ _define_property(this, "claimedDeliveryTimestamp", void 0), /**
   * @generated from field: google.protobuf.Timestamp extracted_sent_timestamp = 23;
   */ _define_property(this, "extractedSentTimestamp", void 0), /**
   * @generated from field: string extracted_sent_raw = 24;
   */ _define_property(this, "extractedSentRaw", ""), /**
   * @generated from field: string extracted_sent_utc_offset = 25;
   */ _define_property(this, "extractedSentUtcOffset", ""), /**
   * @generated from field: string extracted_sent_timezone = 26;
   */ _define_property(this, "extractedSentTimezone", ""), /**
   * @generated from field: google.protobuf.Timestamp accepted_delivery_timestamp = 27;
   */ _define_property(this, "acceptedDeliveryTimestamp", void 0), /**
   * Match|Mismatch|NotFound|Ambiguous|Unsupported
   *
   * @generated from field: string date_verification_state = 28;
   */ _define_property(this, "dateVerificationState", ""), /**
   * ---- SAD-106: customer acceptance + delivery notes (migration 000151) ----
   * customer_acceptance_status is the GOVERNMENT'S response to the
   * delivery — distinct from validation_state above (our own internal QA
   * review of the evidence, tracked via validated_by/validated_at).
   * Exactly one of Accepted|No Response|Rejected, or "" for "not yet
   * recorded" (never "" meaning No Response — that is itself an explicit
   * value a human records).
   *
   * @generated from field: string customer_acceptance_status = 29;
   */ _define_property(this, "customerAcceptanceStatus", ""), /**
   * Free-text delivery notes / exceptions, independent of exception_reason
   * (which stays scoped to the PoD-exception close path above).
   *
   * @generated from field: string delivery_notes = 30;
   */ _define_property(this, "deliveryNotes", ""), /**
   * FK to delivery.contacts, required to resolve to a GOVERNMENT contact
   * (see zou's submitted-to eligibility gate). "" means not recorded via
   * this field — pre-SAD-106 rows carry their submitted-to only in
   * submitted_to_emails (free text), which this field does not replace.
   *
   * @generated from field: string submitted_to_contact_id = 31;
   */ _define_property(this, "submittedToContactId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeliverableEvidence, "runtime", proto3);
_define_property(DeliverableEvidence, "typeName", "mono.datagateway.v1.DeliverableEvidence");
_define_property(DeliverableEvidence, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "program_task_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "evidence_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "external_reference_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "delivery_timestamp",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "submitted_by_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "submitted_to_emails",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 10,
            name: "source_system",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "proof_method",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "screenshot_attached",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 13,
            name: "email_file_attached",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 14,
            name: "customer_receipt_attached",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 15,
            name: "validation_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "validated_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "validated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 18,
            name: "exception_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "audit_event_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 21,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 22,
            name: "claimed_delivery_timestamp",
            kind: "message",
            T: Timestamp
        },
        {
            no: 23,
            name: "extracted_sent_timestamp",
            kind: "message",
            T: Timestamp
        },
        {
            no: 24,
            name: "extracted_sent_raw",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 25,
            name: "extracted_sent_utc_offset",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 26,
            name: "extracted_sent_timezone",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 27,
            name: "accepted_delivery_timestamp",
            kind: "message",
            T: Timestamp
        },
        {
            no: 28,
            name: "date_verification_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 29,
            name: "customer_acceptance_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 30,
            name: "delivery_notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 31,
            name: "submitted_to_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ExternalArtifactReference — wraps non-Specra-stored evidence (GitHub
 * release, SharePoint, Jira ticket, customer portal receipt, email, etc.).
 * May carry a captured_snapshot_artifact_id pointing at a snapshot stored in
 * pangaea's artifact store.
 *
 * @generated from message mono.datagateway.v1.ExternalArtifactReference
 */ export class ExternalArtifactReference extends Message {
    static fromBinary(bytes, options) {
        return new ExternalArtifactReference().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExternalArtifactReference().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExternalArtifactReference().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExternalArtifactReference, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * Github|Sharepoint|Jira|Confluence|CustomerPortal|Email|CloudStorage|Other
   *
   * @generated from field: string source_system = 3;
   */ _define_property(this, "sourceSystem", ""), /**
   * @generated from field: string url_or_identifier = 4;
   */ _define_property(this, "urlOrIdentifier", ""), /**
   * @generated from field: string repository = 5;
   */ _define_property(this, "repository", ""), /**
   * @generated from field: string branch = 6;
   */ _define_property(this, "branch", ""), /**
   * @generated from field: string commit_hash = 7;
   */ _define_property(this, "commitHash", ""), /**
   * @generated from field: string ticket_id = 8;
   */ _define_property(this, "ticketId", ""), /**
   * @generated from field: string sharepoint_url = 9;
   */ _define_property(this, "sharepointUrl", ""), /**
   * @generated from field: string jira_key = 10;
   */ _define_property(this, "jiraKey", ""), /**
   * @generated from field: string access_notes = 11;
   */ _define_property(this, "accessNotes", ""), /**
   * @generated from field: string captured_snapshot_artifact_id = 12;
   */ _define_property(this, "capturedSnapshotArtifactId", ""), /**
   * @generated from field: google.protobuf.Timestamp captured_at = 13;
   */ _define_property(this, "capturedAt", void 0), /**
   * @generated from field: string captured_by = 14;
   */ _define_property(this, "capturedBy", ""), /**
   * @generated from field: string linked_object_type = 15;
   */ _define_property(this, "linkedObjectType", ""), /**
   * @generated from field: string linked_object_id = 16;
   */ _define_property(this, "linkedObjectId", ""), /**
   * LinkOnlyApproved|SnapshotRequired|ExceptionApproved
   *
   * @generated from field: string evidence_policy_status = 17;
   */ _define_property(this, "evidencePolicyStatus", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 18;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 19;
   */ _define_property(this, "updatedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExternalArtifactReference, "runtime", proto3);
_define_property(ExternalArtifactReference, "typeName", "mono.datagateway.v1.ExternalArtifactReference");
_define_property(ExternalArtifactReference, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "source_system",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "url_or_identifier",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "repository",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "branch",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "commit_hash",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "ticket_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "sharepoint_url",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "jira_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "access_notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "captured_snapshot_artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "captured_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 14,
            name: "captured_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "linked_object_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "linked_object_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "evidence_policy_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 19,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * --- BidBaseline ---
 *
 * @generated from message mono.datagateway.v1.FreezeBidBaselineRequest
 */ export class FreezeBidBaselineRequest extends Message {
    static fromBinary(bytes, options) {
        return new FreezeBidBaselineRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FreezeBidBaselineRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FreezeBidBaselineRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FreezeBidBaselineRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.BidBaseline bid_baseline = 1;
   */ _define_property(this, "bidBaseline", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(FreezeBidBaselineRequest, "runtime", proto3);
_define_property(FreezeBidBaselineRequest, "typeName", "mono.datagateway.v1.FreezeBidBaselineRequest");
_define_property(FreezeBidBaselineRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "bid_baseline",
            kind: "message",
            T: BidBaseline
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.FreezeBidBaselineResponse
 */ export class FreezeBidBaselineResponse extends Message {
    static fromBinary(bytes, options) {
        return new FreezeBidBaselineResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FreezeBidBaselineResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FreezeBidBaselineResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FreezeBidBaselineResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.BidBaseline bid_baseline = 1;
   */ _define_property(this, "bidBaseline", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(FreezeBidBaselineResponse, "runtime", proto3);
_define_property(FreezeBidBaselineResponse, "typeName", "mono.datagateway.v1.FreezeBidBaselineResponse");
_define_property(FreezeBidBaselineResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "bid_baseline",
            kind: "message",
            T: BidBaseline
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetBidBaselineRequest
 */ export class GetBidBaselineRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetBidBaselineRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetBidBaselineRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetBidBaselineRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetBidBaselineRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetBidBaselineRequest, "runtime", proto3);
_define_property(GetBidBaselineRequest, "typeName", "mono.datagateway.v1.GetBidBaselineRequest");
_define_property(GetBidBaselineRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetBidBaselineResponse
 */ export class GetBidBaselineResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetBidBaselineResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetBidBaselineResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetBidBaselineResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetBidBaselineResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.BidBaseline bid_baseline = 1;
   */ _define_property(this, "bidBaseline", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetBidBaselineResponse, "runtime", proto3);
_define_property(GetBidBaselineResponse, "typeName", "mono.datagateway.v1.GetBidBaselineResponse");
_define_property(GetBidBaselineResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "bid_baseline",
            kind: "message",
            T: BidBaseline
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.BidBaselineFilter
 */ export class BidBaselineFilter extends Message {
    static fromBinary(bytes, options) {
        return new BidBaselineFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BidBaselineFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BidBaselineFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BidBaselineFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string proposal_project_id = 2;
   */ _define_property(this, "proposalProjectId", ""), /**
   * @generated from field: string pre_award_project_id = 3;
   */ _define_property(this, "preAwardProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(BidBaselineFilter, "runtime", proto3);
_define_property(BidBaselineFilter, "typeName", "mono.datagateway.v1.BidBaselineFilter");
_define_property(BidBaselineFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "proposal_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "pre_award_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListBidBaselinesRequest
 */ export class ListBidBaselinesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListBidBaselinesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListBidBaselinesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListBidBaselinesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListBidBaselinesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.BidBaselineFilter filter = 1;
   */ _define_property(this, "filter", void 0), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListBidBaselinesRequest, "runtime", proto3);
_define_property(ListBidBaselinesRequest, "typeName", "mono.datagateway.v1.ListBidBaselinesRequest");
_define_property(ListBidBaselinesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: BidBaselineFilter
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListBidBaselinesResponse
 */ export class ListBidBaselinesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListBidBaselinesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListBidBaselinesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListBidBaselinesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListBidBaselinesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.BidBaseline bid_baselines = 1;
   */ _define_property(this, "bidBaselines", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListBidBaselinesResponse, "runtime", proto3);
_define_property(ListBidBaselinesResponse, "typeName", "mono.datagateway.v1.ListBidBaselinesResponse");
_define_property(ListBidBaselinesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "bid_baselines",
            kind: "message",
            T: BidBaseline,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * --- PreAwardProject ---
 *
 * @generated from message mono.datagateway.v1.CreatePreAwardProjectRequest
 */ export class CreatePreAwardProjectRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreatePreAwardProjectRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreatePreAwardProjectRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreatePreAwardProjectRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreatePreAwardProjectRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.PreAwardProject pre_award_project = 1;
   */ _define_property(this, "preAwardProject", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreatePreAwardProjectRequest, "runtime", proto3);
_define_property(CreatePreAwardProjectRequest, "typeName", "mono.datagateway.v1.CreatePreAwardProjectRequest");
_define_property(CreatePreAwardProjectRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "pre_award_project",
            kind: "message",
            T: PreAwardProject
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreatePreAwardProjectResponse
 */ export class CreatePreAwardProjectResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreatePreAwardProjectResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreatePreAwardProjectResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreatePreAwardProjectResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreatePreAwardProjectResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.PreAwardProject pre_award_project = 1;
   */ _define_property(this, "preAwardProject", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreatePreAwardProjectResponse, "runtime", proto3);
_define_property(CreatePreAwardProjectResponse, "typeName", "mono.datagateway.v1.CreatePreAwardProjectResponse");
_define_property(CreatePreAwardProjectResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "pre_award_project",
            kind: "message",
            T: PreAwardProject
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetPreAwardProjectRequest
 */ export class GetPreAwardProjectRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetPreAwardProjectRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPreAwardProjectRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPreAwardProjectRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPreAwardProjectRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool include_deleted = 2;
   */ _define_property(this, "includeDeleted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPreAwardProjectRequest, "runtime", proto3);
_define_property(GetPreAwardProjectRequest, "typeName", "mono.datagateway.v1.GetPreAwardProjectRequest");
_define_property(GetPreAwardProjectRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetPreAwardProjectResponse
 */ export class GetPreAwardProjectResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetPreAwardProjectResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPreAwardProjectResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPreAwardProjectResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPreAwardProjectResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.PreAwardProject pre_award_project = 1;
   */ _define_property(this, "preAwardProject", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPreAwardProjectResponse, "runtime", proto3);
_define_property(GetPreAwardProjectResponse, "typeName", "mono.datagateway.v1.GetPreAwardProjectResponse");
_define_property(GetPreAwardProjectResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "pre_award_project",
            kind: "message",
            T: PreAwardProject
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdatePreAwardProjectStateRequest
 */ export class UpdatePreAwardProjectStateRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdatePreAwardProjectStateRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdatePreAwardProjectStateRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdatePreAwardProjectStateRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdatePreAwardProjectStateRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string state = 2;
   */ _define_property(this, "state", ""), /**
   * @generated from field: string updated_by = 3;
   */ _define_property(this, "updatedBy", ""), /**
   * @generated from field: string tenant_id = 4;
   */ _define_property(this, "tenantId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdatePreAwardProjectStateRequest, "runtime", proto3);
_define_property(UpdatePreAwardProjectStateRequest, "typeName", "mono.datagateway.v1.UpdatePreAwardProjectStateRequest");
_define_property(UpdatePreAwardProjectStateRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "updated_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdatePreAwardProjectStateResponse
 */ export class UpdatePreAwardProjectStateResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdatePreAwardProjectStateResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdatePreAwardProjectStateResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdatePreAwardProjectStateResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdatePreAwardProjectStateResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.PreAwardProject pre_award_project = 1;
   */ _define_property(this, "preAwardProject", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdatePreAwardProjectStateResponse, "runtime", proto3);
_define_property(UpdatePreAwardProjectStateResponse, "typeName", "mono.datagateway.v1.UpdatePreAwardProjectStateResponse");
_define_property(UpdatePreAwardProjectStateResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "pre_award_project",
            kind: "message",
            T: PreAwardProject
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.PreAwardProjectFilter
 */ export class PreAwardProjectFilter extends Message {
    static fromBinary(bytes, options) {
        return new PreAwardProjectFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PreAwardProjectFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PreAwardProjectFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PreAwardProjectFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string proposal_project_id = 2;
   */ _define_property(this, "proposalProjectId", ""), /**
   * @generated from field: string state = 3;
   */ _define_property(this, "state", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PreAwardProjectFilter, "runtime", proto3);
_define_property(PreAwardProjectFilter, "typeName", "mono.datagateway.v1.PreAwardProjectFilter");
_define_property(PreAwardProjectFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "proposal_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListPreAwardProjectsRequest
 */ export class ListPreAwardProjectsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListPreAwardProjectsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPreAwardProjectsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPreAwardProjectsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPreAwardProjectsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.PreAwardProjectFilter filter = 1;
   */ _define_property(this, "filter", void 0), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0), /**
   * @generated from field: bool include_deleted = 4;
   */ _define_property(this, "includeDeleted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListPreAwardProjectsRequest, "runtime", proto3);
_define_property(ListPreAwardProjectsRequest, "typeName", "mono.datagateway.v1.ListPreAwardProjectsRequest");
_define_property(ListPreAwardProjectsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: PreAwardProjectFilter
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListPreAwardProjectsResponse
 */ export class ListPreAwardProjectsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListPreAwardProjectsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPreAwardProjectsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPreAwardProjectsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPreAwardProjectsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.PreAwardProject pre_award_projects = 1;
   */ _define_property(this, "preAwardProjects", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListPreAwardProjectsResponse, "runtime", proto3);
_define_property(ListPreAwardProjectsResponse, "typeName", "mono.datagateway.v1.ListPreAwardProjectsResponse");
_define_property(ListPreAwardProjectsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "pre_award_projects",
            kind: "message",
            T: PreAwardProject,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * --- ReadinessPackage ---
 *
 * @generated from message mono.datagateway.v1.UpsertReadinessPackageRequest
 */ export class UpsertReadinessPackageRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertReadinessPackageRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertReadinessPackageRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertReadinessPackageRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertReadinessPackageRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ReadinessPackage readiness_package = 1;
   */ _define_property(this, "readinessPackage", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertReadinessPackageRequest, "runtime", proto3);
_define_property(UpsertReadinessPackageRequest, "typeName", "mono.datagateway.v1.UpsertReadinessPackageRequest");
_define_property(UpsertReadinessPackageRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "readiness_package",
            kind: "message",
            T: ReadinessPackage
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertReadinessPackageResponse
 */ export class UpsertReadinessPackageResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertReadinessPackageResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertReadinessPackageResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertReadinessPackageResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertReadinessPackageResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ReadinessPackage readiness_package = 1;
   */ _define_property(this, "readinessPackage", void 0), /**
   * @generated from field: bool created = 2;
   */ _define_property(this, "created", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertReadinessPackageResponse, "runtime", proto3);
_define_property(UpsertReadinessPackageResponse, "typeName", "mono.datagateway.v1.UpsertReadinessPackageResponse");
_define_property(UpsertReadinessPackageResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "readiness_package",
            kind: "message",
            T: ReadinessPackage
        },
        {
            no: 2,
            name: "created",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetReadinessPackageRequest
 */ export class GetReadinessPackageRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetReadinessPackageRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetReadinessPackageRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetReadinessPackageRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetReadinessPackageRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetReadinessPackageRequest, "runtime", proto3);
_define_property(GetReadinessPackageRequest, "typeName", "mono.datagateway.v1.GetReadinessPackageRequest");
_define_property(GetReadinessPackageRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetReadinessPackageResponse
 */ export class GetReadinessPackageResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetReadinessPackageResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetReadinessPackageResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetReadinessPackageResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetReadinessPackageResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ReadinessPackage readiness_package = 1;
   */ _define_property(this, "readinessPackage", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetReadinessPackageResponse, "runtime", proto3);
_define_property(GetReadinessPackageResponse, "typeName", "mono.datagateway.v1.GetReadinessPackageResponse");
_define_property(GetReadinessPackageResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "readiness_package",
            kind: "message",
            T: ReadinessPackage
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ReadinessPackageFilter
 */ export class ReadinessPackageFilter extends Message {
    static fromBinary(bytes, options) {
        return new ReadinessPackageFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReadinessPackageFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReadinessPackageFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReadinessPackageFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string pre_award_project_id = 2;
   */ _define_property(this, "preAwardProjectId", ""), /**
   * @generated from field: string area = 3;
   */ _define_property(this, "area", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReadinessPackageFilter, "runtime", proto3);
_define_property(ReadinessPackageFilter, "typeName", "mono.datagateway.v1.ReadinessPackageFilter");
_define_property(ReadinessPackageFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "pre_award_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "area",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListReadinessPackagesRequest
 */ export class ListReadinessPackagesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListReadinessPackagesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListReadinessPackagesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListReadinessPackagesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListReadinessPackagesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ReadinessPackageFilter filter = 1;
   */ _define_property(this, "filter", void 0), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListReadinessPackagesRequest, "runtime", proto3);
_define_property(ListReadinessPackagesRequest, "typeName", "mono.datagateway.v1.ListReadinessPackagesRequest");
_define_property(ListReadinessPackagesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: ReadinessPackageFilter
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListReadinessPackagesResponse
 */ export class ListReadinessPackagesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListReadinessPackagesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListReadinessPackagesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListReadinessPackagesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListReadinessPackagesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.ReadinessPackage readiness_packages = 1;
   */ _define_property(this, "readinessPackages", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListReadinessPackagesResponse, "runtime", proto3);
_define_property(ListReadinessPackagesResponse, "typeName", "mono.datagateway.v1.ListReadinessPackagesResponse");
_define_property(ListReadinessPackagesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "readiness_packages",
            kind: "message",
            T: ReadinessPackage,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * ContractChangeSet — the canonical change-set envelope covering award imports
 * AND modifications (corrective spec §8). Items hang off it via change_set_id.
 *
 * @generated from message mono.datagateway.v1.ContractChangeSet
 */ export class ContractChangeSet extends Message {
    static fromBinary(bytes, options) {
        return new ContractChangeSet().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractChangeSet().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractChangeSet().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractChangeSet, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * AwardImport|Modification|ManualCorrection|ReExtraction|PricingSheet|ExecutionScopeImport|ExecutionScopeRevision|ExecutionScopeManualCorrection
   *
   * @generated from field: string change_set_type = 3;
   */ _define_property(this, "changeSetType", ""), /**
   * nullable until a Contract Project exists
   *
   * @generated from field: string program_id = 4;
   */ _define_property(this, "programId", ""), /**
   * Draft|Parsed|UnderReview|Approved|Applied|Rejected|Cancelled|Superseded
   *
   * @generated from field: string state = 5;
   */ _define_property(this, "state", ""), /**
   * @generated from field: repeated string source_artifact_ids = 6;
   */ _define_property(this, "sourceArtifactIds", []), /**
   * @generated from field: string source_modification_id = 7;
   */ _define_property(this, "sourceModificationId", ""), /**
   * @generated from field: string title = 8;
   */ _define_property(this, "title", ""), /**
   * @generated from field: google.protobuf.Timestamp applied_at = 9;
   */ _define_property(this, "appliedAt", void 0), /**
   * @generated from field: string applied_by = 10;
   */ _define_property(this, "appliedBy", ""), /**
   * @generated from field: string applied_event_id = 11;
   */ _define_property(this, "appliedEventId", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 12;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: string created_by = 13;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 14;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: string updated_by = 15;
   */ _define_property(this, "updatedBy", ""), /**
   * Award-import provenance (nullable; set only for change_set_type=AwardImport).
   * Carries the pre-award/proposal linkage the award-comparison flow scopes on.
   *
   * @generated from field: string pre_award_project_id = 16;
   */ _define_property(this, "preAwardProjectId", ""), /**
   * @generated from field: string proposal_project_id = 17;
   */ _define_property(this, "proposalProjectId", ""), /**
   * Why the set is in its current state; set when a reviewer ends it without
   * a replacement (a discard's reason, a rejection's). Read-only on the wire.
   *
   * @generated from field: string state_reason = 18;
   */ _define_property(this, "stateReason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractChangeSet, "runtime", proto3);
_define_property(ContractChangeSet, "typeName", "mono.datagateway.v1.ContractChangeSet");
_define_property(ContractChangeSet, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "change_set_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "source_artifact_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 7,
            name: "source_modification_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "applied_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "applied_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "applied_event_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 13,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 15,
            name: "updated_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "pre_award_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "proposal_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "state_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ContractChangeItem — one proposed/applyable diff inside a change set
 * (corrective spec §7.3). diff_type/change_category classify it; the value_json
 * fields carry current/extracted/proposed/approved; impact_json previews
 * downstream effects; apply/supersession links close the loop in 4d.
 *
 * @generated from message mono.datagateway.v1.ContractChangeItem
 */ export class ContractChangeItem extends Message {
    static fromBinary(bytes, options) {
        return new ContractChangeItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractChangeItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractChangeItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractChangeItem, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string change_set_id = 3;
   */ _define_property(this, "changeSetId", ""), /**
   * @generated from field: string program_modification_id = 4;
   */ _define_property(this, "programModificationId", ""), /**
   * @generated from field: string target_object_type = 5;
   */ _define_property(this, "targetObjectType", ""), /**
   * @generated from field: string target_object_id = 6;
   */ _define_property(this, "targetObjectId", ""), /**
   * @generated from field: string target_field_path = 7;
   */ _define_property(this, "targetFieldPath", ""), /**
   * @generated from field: string change_type = 8;
   */ _define_property(this, "changeType", ""), /**
   * Field|Object|Text|Calendar|Financial|Evidence|Authority
   *
   * @generated from field: string diff_type = 9;
   */ _define_property(this, "diffType", ""), /**
   * Scope|Funding|Period|Option|Deliverable|POC|Staffing|Subcontract|Compliance|Admin
   *
   * @generated from field: string change_category = 10;
   */ _define_property(this, "changeCategory", ""), /**
   * @generated from field: string current_authoritative_value_json = 11;
   */ _define_property(this, "currentAuthoritativeValueJson", ""), /**
   * @generated from field: string previous_value_json = 12;
   */ _define_property(this, "previousValueJson", ""), /**
   * @generated from field: string extracted_value_json = 13;
   */ _define_property(this, "extractedValueJson", ""), /**
   * @generated from field: string proposed_value_json = 14;
   */ _define_property(this, "proposedValueJson", ""), /**
   * @generated from field: string approved_value_json = 15;
   */ _define_property(this, "approvedValueJson", ""), /**
   * Informational|Moderate|High|Blocking
   *
   * @generated from field: string severity = 16;
   */ _define_property(this, "severity", ""), /**
   * Delivery|Contracts|Finance|Subcontracts|HrOnboarding|Quality|Deliverables|GrowthHandoff
   *
   * @generated from field: string functional_owner = 17;
   */ _define_property(this, "functionalOwner", ""), /**
   * Open|Routed|Accepted|Corrected|Waived|Rejected|Escalated|Applied|Closed
   *
   * @generated from field: string resolution_state = 18;
   */ _define_property(this, "resolutionState", ""), /**
   * @generated from field: string decision_rationale = 19;
   */ _define_property(this, "decisionRationale", ""), /**
   * @generated from field: google.protobuf.Timestamp decided_at = 20;
   */ _define_property(this, "decidedAt", void 0), /**
   * @generated from field: string source_reference_id = 21;
   */ _define_property(this, "sourceReferenceId", ""), /**
   * @generated from field: string source_before_reference_id = 22;
   */ _define_property(this, "sourceBeforeReferenceId", ""), /**
   * @generated from field: string source_after_reference_id = 23;
   */ _define_property(this, "sourceAfterReferenceId", ""), /**
   * @generated from field: string impact_json = 24;
   */ _define_property(this, "impactJson", ""), /**
   * @generated from field: string applied_event_id = 25;
   */ _define_property(this, "appliedEventId", ""), /**
   * @generated from field: string supersedes_change_item_id = 26;
   */ _define_property(this, "supersedesChangeItemId", ""), /**
   * @generated from field: string superseded_object_id = 27;
   */ _define_property(this, "supersededObjectId", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 28;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 29;
   */ _define_property(this, "updatedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractChangeItem, "runtime", proto3);
_define_property(ContractChangeItem, "typeName", "mono.datagateway.v1.ContractChangeItem");
_define_property(ContractChangeItem, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "program_modification_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "target_object_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "target_object_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "target_field_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "change_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "diff_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "change_category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "current_authoritative_value_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "previous_value_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "extracted_value_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "proposed_value_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "approved_value_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "severity",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "functional_owner",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "resolution_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "decision_rationale",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "decided_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 21,
            name: "source_reference_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 22,
            name: "source_before_reference_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 23,
            name: "source_after_reference_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 24,
            name: "impact_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 25,
            name: "applied_event_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 26,
            name: "supersedes_change_item_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 27,
            name: "superseded_object_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 28,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 29,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * --- ContractChangeSet RPC messages ---
 *
 * @generated from message mono.datagateway.v1.CreateContractChangeSetRequest
 */ export class CreateContractChangeSetRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateContractChangeSetRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateContractChangeSetRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateContractChangeSetRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateContractChangeSetRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractChangeSet change_set = 1;
   */ _define_property(this, "changeSet", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateContractChangeSetRequest, "runtime", proto3);
_define_property(CreateContractChangeSetRequest, "typeName", "mono.datagateway.v1.CreateContractChangeSetRequest");
_define_property(CreateContractChangeSetRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "change_set",
            kind: "message",
            T: ContractChangeSet
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateContractChangeSetResponse
 */ export class CreateContractChangeSetResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateContractChangeSetResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateContractChangeSetResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateContractChangeSetResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateContractChangeSetResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractChangeSet change_set = 1;
   */ _define_property(this, "changeSet", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateContractChangeSetResponse, "runtime", proto3);
_define_property(CreateContractChangeSetResponse, "typeName", "mono.datagateway.v1.CreateContractChangeSetResponse");
_define_property(CreateContractChangeSetResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "change_set",
            kind: "message",
            T: ContractChangeSet
        }
    ]));
/**
 * Atomically publish an award comparison only if the prior review is unchanged.
 *
 * @generated from message mono.datagateway.v1.ReplaceAwardComparisonRequest
 */ export class ReplaceAwardComparisonRequest extends Message {
    static fromBinary(bytes, options) {
        return new ReplaceAwardComparisonRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReplaceAwardComparisonRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReplaceAwardComparisonRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReplaceAwardComparisonRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractChangeSet change_set = 1;
   */ _define_property(this, "changeSet", void 0), /**
   * @generated from field: repeated mono.datagateway.v1.ContractChangeItem items = 2;
   */ _define_property(this, "items", []), /**
   * @generated from field: repeated mono.datagateway.v1.SourceReference references = 3;
   */ _define_property(this, "references", []), /**
   * @generated from field: string previous_change_set_id = 4;
   */ _define_property(this, "previousChangeSetId", ""), /**
   * @generated from field: google.protobuf.Timestamp previous_updated_at = 5;
   */ _define_property(this, "previousUpdatedAt", void 0), /**
   * @generated from field: map<string, google.protobuf.Timestamp> previous_item_updated_at = 6;
   */ _define_property(this, "previousItemUpdatedAt", {}), /**
   * Optional for synchronous imports; required for a leased background run.
   *
   * @generated from field: string award_run_id = 7;
   */ _define_property(this, "awardRunId", ""), /**
   * @generated from field: string worker_token = 8;
   */ _define_property(this, "workerToken", ""), /**
   * Serialized ExtractionCacheInfo, retained on the completed run.
   *
   * @generated from field: string cache_info_json = 9;
   */ _define_property(this, "cacheInfoJson", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReplaceAwardComparisonRequest, "runtime", proto3);
_define_property(ReplaceAwardComparisonRequest, "typeName", "mono.datagateway.v1.ReplaceAwardComparisonRequest");
_define_property(ReplaceAwardComparisonRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "change_set",
            kind: "message",
            T: ContractChangeSet
        },
        {
            no: 2,
            name: "items",
            kind: "message",
            T: ContractChangeItem,
            repeated: true
        },
        {
            no: 3,
            name: "references",
            kind: "message",
            T: SourceReference,
            repeated: true
        },
        {
            no: 4,
            name: "previous_change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "previous_updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "previous_item_updated_at",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "message",
                T: Timestamp
            }
        },
        {
            no: 7,
            name: "award_run_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "worker_token",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "cache_info_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ReplaceAwardComparisonResponse
 */ export class ReplaceAwardComparisonResponse extends Message {
    static fromBinary(bytes, options) {
        return new ReplaceAwardComparisonResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReplaceAwardComparisonResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReplaceAwardComparisonResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReplaceAwardComparisonResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractChangeSet change_set = 1;
   */ _define_property(this, "changeSet", void 0), /**
   * @generated from field: repeated mono.datagateway.v1.ContractChangeItem items = 2;
   */ _define_property(this, "items", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReplaceAwardComparisonResponse, "runtime", proto3);
_define_property(ReplaceAwardComparisonResponse, "typeName", "mono.datagateway.v1.ReplaceAwardComparisonResponse");
_define_property(ReplaceAwardComparisonResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "change_set",
            kind: "message",
            T: ContractChangeSet
        },
        {
            no: 2,
            name: "items",
            kind: "message",
            T: ContractChangeItem,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetContractChangeSetRequest
 */ export class GetContractChangeSetRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetContractChangeSetRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetContractChangeSetRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetContractChangeSetRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetContractChangeSetRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetContractChangeSetRequest, "runtime", proto3);
_define_property(GetContractChangeSetRequest, "typeName", "mono.datagateway.v1.GetContractChangeSetRequest");
_define_property(GetContractChangeSetRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetContractChangeSetResponse
 */ export class GetContractChangeSetResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetContractChangeSetResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetContractChangeSetResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetContractChangeSetResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetContractChangeSetResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractChangeSet change_set = 1;
   */ _define_property(this, "changeSet", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetContractChangeSetResponse, "runtime", proto3);
_define_property(GetContractChangeSetResponse, "typeName", "mono.datagateway.v1.GetContractChangeSetResponse");
_define_property(GetContractChangeSetResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "change_set",
            kind: "message",
            T: ContractChangeSet
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateContractChangeSetStateRequest
 */ export class UpdateContractChangeSetStateRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateContractChangeSetStateRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateContractChangeSetStateRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateContractChangeSetStateRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateContractChangeSetStateRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string state = 2;
   */ _define_property(this, "state", ""), /**
   * @generated from field: string updated_by = 3;
   */ _define_property(this, "updatedBy", ""), /**
   * @generated from field: string tenant_id = 4;
   */ _define_property(this, "tenantId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateContractChangeSetStateRequest, "runtime", proto3);
_define_property(UpdateContractChangeSetStateRequest, "typeName", "mono.datagateway.v1.UpdateContractChangeSetStateRequest");
_define_property(UpdateContractChangeSetStateRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "updated_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateContractChangeSetStateResponse
 */ export class UpdateContractChangeSetStateResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateContractChangeSetStateResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateContractChangeSetStateResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateContractChangeSetStateResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateContractChangeSetStateResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractChangeSet change_set = 1;
   */ _define_property(this, "changeSet", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateContractChangeSetStateResponse, "runtime", proto3);
_define_property(UpdateContractChangeSetStateResponse, "typeName", "mono.datagateway.v1.UpdateContractChangeSetStateResponse");
_define_property(UpdateContractChangeSetStateResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "change_set",
            kind: "message",
            T: ContractChangeSet
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.LinkProgramAndApplyChangeSetRequest
 */ export class LinkProgramAndApplyChangeSetRequest extends Message {
    static fromBinary(bytes, options) {
        return new LinkProgramAndApplyChangeSetRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LinkProgramAndApplyChangeSetRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LinkProgramAndApplyChangeSetRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LinkProgramAndApplyChangeSetRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string change_set_id = 1;
   */ _define_property(this, "changeSetId", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string applied_by = 3;
   */ _define_property(this, "appliedBy", ""), /**
   * @generated from field: string tenant_id = 4;
   */ _define_property(this, "tenantId", ""), /**
   * optional
   *
   * @generated from field: string applied_event_id = 5;
   */ _define_property(this, "appliedEventId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LinkProgramAndApplyChangeSetRequest, "runtime", proto3);
_define_property(LinkProgramAndApplyChangeSetRequest, "typeName", "mono.datagateway.v1.LinkProgramAndApplyChangeSetRequest");
_define_property(LinkProgramAndApplyChangeSetRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "applied_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "applied_event_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.LinkProgramAndApplyChangeSetResponse
 */ export class LinkProgramAndApplyChangeSetResponse extends Message {
    static fromBinary(bytes, options) {
        return new LinkProgramAndApplyChangeSetResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LinkProgramAndApplyChangeSetResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LinkProgramAndApplyChangeSetResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LinkProgramAndApplyChangeSetResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractChangeSet change_set = 1;
   */ _define_property(this, "changeSet", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(LinkProgramAndApplyChangeSetResponse, "runtime", proto3);
_define_property(LinkProgramAndApplyChangeSetResponse, "typeName", "mono.datagateway.v1.LinkProgramAndApplyChangeSetResponse");
_define_property(LinkProgramAndApplyChangeSetResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "change_set",
            kind: "message",
            T: ContractChangeSet
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ApplyChangeSetRequest
 */ export class ApplyChangeSetRequest extends Message {
    static fromBinary(bytes, options) {
        return new ApplyChangeSetRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ApplyChangeSetRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ApplyChangeSetRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ApplyChangeSetRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string change_set_id = 2;
   */ _define_property(this, "changeSetId", ""), /**
   * optional: set on the set at apply (award link); empty for mods already linked
   *
   * @generated from field: string program_id = 3;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string applied_by = 4;
   */ _define_property(this, "appliedBy", ""), /**
   * optional; minted if empty
   *
   * @generated from field: string correlation_id = 5;
   */ _define_property(this, "correlationId", ""), /**
   * Pre-flight (SAD-702): run the whole apply and roll it back. A strict
   * refusal (D87) comes back exactly as the real apply would return it, and
   * a pass writes nothing: the set stays in flight, no lineage, no audit
   * event, no Applied stamp. An AwardImport with no program yet is applied
   * against a throwaway program row that rolls back with everything else,
   * so the caller can find a refusal before it creates the real one.
   *
   * @generated from field: bool dry_run = 6;
   */ _define_property(this, "dryRun", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ApplyChangeSetRequest, "runtime", proto3);
_define_property(ApplyChangeSetRequest, "typeName", "mono.datagateway.v1.ApplyChangeSetRequest");
_define_property(ApplyChangeSetRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "applied_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "correlation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "dry_run",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ApplyChangeSetResponse
 */ export class ApplyChangeSetResponse extends Message {
    static fromBinary(bytes, options) {
        return new ApplyChangeSetResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ApplyChangeSetResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ApplyChangeSetResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ApplyChangeSetResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractChangeSet change_set = 1;
   */ _define_property(this, "changeSet", void 0), /**
   * items whose value was written
   *
   * @generated from field: int32 applied_count = 2;
   */ _define_property(this, "appliedCount", 0), /**
   * items skipped (not approved, no-op value, unsupported target)
   *
   * @generated from field: int32 skipped_count = 3;
   */ _define_property(this, "skippedCount", 0), /**
   * unsupported (target_object_type, field_path) pairs, decode failures
   *
   * @generated from field: repeated string warnings = 4;
   */ _define_property(this, "warnings", []), /**
   * envelope operational_audit_event id
   *
   * @generated from field: string applied_event_id = 5;
   */ _define_property(this, "appliedEventId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ApplyChangeSetResponse, "runtime", proto3);
_define_property(ApplyChangeSetResponse, "typeName", "mono.datagateway.v1.ApplyChangeSetResponse");
_define_property(ApplyChangeSetResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "change_set",
            kind: "message",
            T: ContractChangeSet
        },
        {
            no: 2,
            name: "applied_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "skipped_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "warnings",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 5,
            name: "applied_event_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DiscardContractChangeSetRequest
 */ export class DiscardContractChangeSetRequest extends Message {
    static fromBinary(bytes, options) {
        return new DiscardContractChangeSetRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DiscardContractChangeSetRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DiscardContractChangeSetRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DiscardContractChangeSetRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string change_set_id = 2;
   */ _define_property(this, "changeSetId", ""), /**
   * required unless dry_run
   *
   * @generated from field: string reason = 3;
   */ _define_property(this, "reason", ""), /**
   * @generated from field: string discarded_by = 4;
   */ _define_property(this, "discardedBy", ""), /**
   * @generated from field: bool remove_document = 5;
   */ _define_property(this, "removeDocument", false), /**
   * @generated from field: bool dry_run = 6;
   */ _define_property(this, "dryRun", false), /**
   * optional; minted if empty
   *
   * @generated from field: string correlation_id = 7;
   */ _define_property(this, "correlationId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DiscardContractChangeSetRequest, "runtime", proto3);
_define_property(DiscardContractChangeSetRequest, "typeName", "mono.datagateway.v1.DiscardContractChangeSetRequest");
_define_property(DiscardContractChangeSetRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "discarded_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "remove_document",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "dry_run",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 7,
            name: "correlation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DiscardContractChangeSetResponse
 */ export class DiscardContractChangeSetResponse extends Message {
    static fromBinary(bytes, options) {
        return new DiscardContractChangeSetResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DiscardContractChangeSetResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DiscardContractChangeSetResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DiscardContractChangeSetResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractChangeSet change_set = 1;
   */ _define_property(this, "changeSet", void 0), /**
   * @generated from field: int32 closed_item_count = 2;
   */ _define_property(this, "closedItemCount", 0), /**
   * The set's uploaded document ids (source_artifact_ids); empty when the
   * set was staged from no upload.
   *
   * @generated from field: repeated string document_ids = 3;
   */ _define_property(this, "documentIds", []), /**
   * What else still references the document, one sentence each; empty when
   * it can be removed.
   *
   * @generated from field: repeated string document_references = 4;
   */ _define_property(this, "documentReferences", []), /**
   * @generated from field: bool document_removed = 5;
   */ _define_property(this, "documentRemoved", false), /**
   * @generated from field: string audit_event_id = 6;
   */ _define_property(this, "auditEventId", ""), /**
   * document_references with the record each one names, in the same order.
   *
   * @generated from field: repeated mono.datagateway.v1.ChangeSetDocumentReference document_reference_records = 7;
   */ _define_property(this, "documentReferenceRecords", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DiscardContractChangeSetResponse, "runtime", proto3);
_define_property(DiscardContractChangeSetResponse, "typeName", "mono.datagateway.v1.DiscardContractChangeSetResponse");
_define_property(DiscardContractChangeSetResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "change_set",
            kind: "message",
            T: ContractChangeSet
        },
        {
            no: 2,
            name: "closed_item_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "document_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 4,
            name: "document_references",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 5,
            name: "document_removed",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "audit_event_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "document_reference_records",
            kind: "message",
            T: ChangeSetDocumentReference,
            repeated: true
        }
    ]));
/**
 * ChangeSetDocumentReference is one thing still citing a change set's
 * document. record_id is the citing row's id (a change set, a registry row),
 * or the table for a counted group; description is distinct per record.
 *
 * @generated from message mono.datagateway.v1.ChangeSetDocumentReference
 */ export class ChangeSetDocumentReference extends Message {
    static fromBinary(bytes, options) {
        return new ChangeSetDocumentReference().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ChangeSetDocumentReference().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ChangeSetDocumentReference().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ChangeSetDocumentReference, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string record_id = 1;
   */ _define_property(this, "recordId", ""), /**
   * @generated from field: string description = 2;
   */ _define_property(this, "description", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ChangeSetDocumentReference, "runtime", proto3);
_define_property(ChangeSetDocumentReference, "typeName", "mono.datagateway.v1.ChangeSetDocumentReference");
_define_property(ChangeSetDocumentReference, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "record_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ApplyRefusal is the Connect error detail ApplyChangeSet (and the commits
 * that call it) attaches when it refuses because of review items: one
 * refusal per item, so the reviewer reads what is wrong and opens the item.
 *
 * @generated from message mono.datagateway.v1.ApplyRefusal
 */ export class ApplyRefusal extends Message {
    static fromBinary(bytes, options) {
        return new ApplyRefusal().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ApplyRefusal().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ApplyRefusal().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ApplyRefusal, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.ChangeItemRefusal refusals = 1;
   */ _define_property(this, "refusals", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ApplyRefusal, "runtime", proto3);
_define_property(ApplyRefusal, "typeName", "mono.datagateway.v1.ApplyRefusal");
_define_property(ApplyRefusal, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "refusals",
            kind: "message",
            T: ChangeItemRefusal,
            repeated: true
        }
    ]));
/**
 * ChangeItemRefusal is one item a commit refused on, in the reviewer's words.
 *
 * @generated from message mono.datagateway.v1.ChangeItemRefusal
 */ export class ChangeItemRefusal extends Message {
    static fromBinary(bytes, options) {
        return new ChangeItemRefusal().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ChangeItemRefusal().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ChangeItemRefusal().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ChangeItemRefusal, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string change_set_id = 1;
   */ _define_property(this, "changeSetId", ""), /**
   * item_id is the stored item's id. An apply-only copy of an item (a line's
   * end date, another line the same decision names) carries its source
   * item's id; line says which line it was for.
   *
   * @generated from field: string item_id = 2;
   */ _define_property(this, "itemId", ""), /**
   * ContractCLIN, ContractDuty, ...
   *
   * @generated from field: string target_object_type = 3;
   */ _define_property(this, "targetObjectType", ""), /**
   * "CLIN 5001BB", "CLIN 0001AB \"Biweekly Status Report\""
   *
   * @generated from field: string target_label = 4;
   */ _define_property(this, "targetLabel", ""), /**
   * "start date", "schedule rule"
   *
   * @generated from field: string field_label = 5;
   */ _define_property(this, "fieldLabel", ""), /**
   * the value the decision was made against or picked ("" = none)
   *
   * @generated from field: string reviewed_value = 6;
   */ _define_property(this, "reviewedValue", ""), /**
   * what the program holds now, where it matters ("" = none)
   *
   * @generated from field: string current_value = 7;
   */ _define_property(this, "currentValue", ""), /**
   * stable: LINE_NOT_ON_CONTRACT, CHANGED_SINCE_REVIEW, RULE_REPLACED, ...
   *
   * @generated from field: string reason_code = 8;
   */ _define_property(this, "reasonCode", ""), /**
   * one sentence: what is wrong
   *
   * @generated from field: string reason = 9;
   */ _define_property(this, "reason", ""), /**
   * one sentence: what to do
   *
   * @generated from field: string next_action = 10;
   */ _define_property(this, "nextAction", ""), /**
   * the line an apply-only copy was for ("" = the item's own target)
   *
   * @generated from field: string line = 11;
   */ _define_property(this, "line", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ChangeItemRefusal, "runtime", proto3);
_define_property(ChangeItemRefusal, "typeName", "mono.datagateway.v1.ChangeItemRefusal");
_define_property(ChangeItemRefusal, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "item_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "target_object_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "target_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "field_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "reviewed_value",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "current_value",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "reason_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "next_action",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "line",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ContractChangeSetFilter
 */ export class ContractChangeSetFilter extends Message {
    static fromBinary(bytes, options) {
        return new ContractChangeSetFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractChangeSetFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractChangeSetFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractChangeSetFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string change_set_type = 2;
   */ _define_property(this, "changeSetType", ""), /**
   * @generated from field: string program_id = 3;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string state = 4;
   */ _define_property(this, "state", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractChangeSetFilter, "runtime", proto3);
_define_property(ContractChangeSetFilter, "typeName", "mono.datagateway.v1.ContractChangeSetFilter");
_define_property(ContractChangeSetFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "change_set_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListContractChangeSetsRequest
 */ export class ListContractChangeSetsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListContractChangeSetsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListContractChangeSetsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListContractChangeSetsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListContractChangeSetsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractChangeSetFilter filter = 1;
   */ _define_property(this, "filter", void 0), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListContractChangeSetsRequest, "runtime", proto3);
_define_property(ListContractChangeSetsRequest, "typeName", "mono.datagateway.v1.ListContractChangeSetsRequest");
_define_property(ListContractChangeSetsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: ContractChangeSetFilter
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListContractChangeSetsResponse
 */ export class ListContractChangeSetsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListContractChangeSetsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListContractChangeSetsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListContractChangeSetsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListContractChangeSetsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.ContractChangeSet change_sets = 1;
   */ _define_property(this, "changeSets", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListContractChangeSetsResponse, "runtime", proto3);
_define_property(ListContractChangeSetsResponse, "typeName", "mono.datagateway.v1.ListContractChangeSetsResponse");
_define_property(ListContractChangeSetsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "change_sets",
            kind: "message",
            T: ContractChangeSet,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * --- ContractChangeItem RPC messages ---
 *
 * @generated from message mono.datagateway.v1.BulkInsertContractChangeItemsRequest
 */ export class BulkInsertContractChangeItemsRequest extends Message {
    static fromBinary(bytes, options) {
        return new BulkInsertContractChangeItemsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BulkInsertContractChangeItemsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BulkInsertContractChangeItemsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BulkInsertContractChangeItemsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.ContractChangeItem items = 1;
   */ _define_property(this, "items", []), /**
   * A later document's statements (D96), reconciled against the program's
   * review items on file inside the staging transaction.
   *
   * @generated from field: mono.datagateway.v1.ReviewStatementBatch review_statements = 2;
   */ _define_property(this, "reviewStatements", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(BulkInsertContractChangeItemsRequest, "runtime", proto3);
_define_property(BulkInsertContractChangeItemsRequest, "typeName", "mono.datagateway.v1.BulkInsertContractChangeItemsRequest");
_define_property(BulkInsertContractChangeItemsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "items",
            kind: "message",
            T: ContractChangeItem,
            repeated: true
        },
        {
            no: 2,
            name: "review_statements",
            kind: "message",
            T: ReviewStatementBatch
        }
    ]));
/**
 * ReviewStatementBatch is what one Modification set's document states (D96).
 *
 * @generated from message mono.datagateway.v1.ReviewStatementBatch
 */ export class ReviewStatementBatch extends Message {
    static fromBinary(bytes, options) {
        return new ReviewStatementBatch().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReviewStatementBatch().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReviewStatementBatch().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReviewStatementBatch, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string change_set_id = 2;
   */ _define_property(this, "changeSetId", ""), /**
   * @generated from field: repeated mono.common.v1.ReviewStatement statements = 3;
   */ _define_property(this, "statements", []), /**
   * The effective date the modification states (YYYY-MM-DD), empty when it
   * states none (D88: a stated date only). The lineage chronology orders the
   * set's entries by it.
   *
   * @generated from field: string effective_date = 4;
   */ _define_property(this, "effectiveDate", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReviewStatementBatch, "runtime", proto3);
_define_property(ReviewStatementBatch, "typeName", "mono.datagateway.v1.ReviewStatementBatch");
_define_property(ReviewStatementBatch, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "statements",
            kind: "message",
            T: ReviewStatement,
            repeated: true
        },
        {
            no: 4,
            name: "effective_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.BulkInsertContractChangeItemsResponse
 */ export class BulkInsertContractChangeItemsResponse extends Message {
    static fromBinary(bytes, options) {
        return new BulkInsertContractChangeItemsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BulkInsertContractChangeItemsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BulkInsertContractChangeItemsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BulkInsertContractChangeItemsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 inserted = 1;
   */ _define_property(this, "inserted", 0), /**
   * @generated from field: repeated mono.datagateway.v1.ContractChangeItem items = 2;
   */ _define_property(this, "items", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(BulkInsertContractChangeItemsResponse, "runtime", proto3);
_define_property(BulkInsertContractChangeItemsResponse, "typeName", "mono.datagateway.v1.BulkInsertContractChangeItemsResponse");
_define_property(BulkInsertContractChangeItemsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "inserted",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "items",
            kind: "message",
            T: ContractChangeItem,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetContractChangeItemRequest
 */ export class GetContractChangeItemRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetContractChangeItemRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetContractChangeItemRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetContractChangeItemRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetContractChangeItemRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetContractChangeItemRequest, "runtime", proto3);
_define_property(GetContractChangeItemRequest, "typeName", "mono.datagateway.v1.GetContractChangeItemRequest");
_define_property(GetContractChangeItemRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetContractChangeItemResponse
 */ export class GetContractChangeItemResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetContractChangeItemResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetContractChangeItemResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetContractChangeItemResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetContractChangeItemResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractChangeItem item = 1;
   */ _define_property(this, "item", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetContractChangeItemResponse, "runtime", proto3);
_define_property(GetContractChangeItemResponse, "typeName", "mono.datagateway.v1.GetContractChangeItemResponse");
_define_property(GetContractChangeItemResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "item",
            kind: "message",
            T: ContractChangeItem
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateContractChangeItemResolutionRequest
 */ export class UpdateContractChangeItemResolutionRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateContractChangeItemResolutionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateContractChangeItemResolutionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateContractChangeItemResolutionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateContractChangeItemResolutionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string resolution_state = 3;
   */ _define_property(this, "resolutionState", ""), /**
   * @generated from field: string decision_rationale = 4;
   */ _define_property(this, "decisionRationale", ""), /**
   * @generated from field: string approved_value_json = 5;
   */ _define_property(this, "approvedValueJson", ""), /**
   * optional re-route
   *
   * @generated from field: string functional_owner = 6;
   */ _define_property(this, "functionalOwner", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateContractChangeItemResolutionRequest, "runtime", proto3);
_define_property(UpdateContractChangeItemResolutionRequest, "typeName", "mono.datagateway.v1.UpdateContractChangeItemResolutionRequest");
_define_property(UpdateContractChangeItemResolutionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "resolution_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "decision_rationale",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "approved_value_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "functional_owner",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateContractChangeItemResolutionResponse
 */ export class UpdateContractChangeItemResolutionResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateContractChangeItemResolutionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateContractChangeItemResolutionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateContractChangeItemResolutionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateContractChangeItemResolutionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractChangeItem item = 1;
   */ _define_property(this, "item", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateContractChangeItemResolutionResponse, "runtime", proto3);
_define_property(UpdateContractChangeItemResolutionResponse, "typeName", "mono.datagateway.v1.UpdateContractChangeItemResolutionResponse");
_define_property(UpdateContractChangeItemResolutionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "item",
            kind: "message",
            T: ContractChangeItem
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SetContractChangeItemTargetRequest
 */ export class SetContractChangeItemTargetRequest extends Message {
    static fromBinary(bytes, options) {
        return new SetContractChangeItemTargetRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetContractChangeItemTargetRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetContractChangeItemTargetRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetContractChangeItemTargetRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * A PeriodOfPerformance, ContractCLIN or OptionalTask row id, matching the
   * item's target_object_type.
   *
   * @generated from field: string target_object_id = 3;
   */ _define_property(this, "targetObjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetContractChangeItemTargetRequest, "runtime", proto3);
_define_property(SetContractChangeItemTargetRequest, "typeName", "mono.datagateway.v1.SetContractChangeItemTargetRequest");
_define_property(SetContractChangeItemTargetRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "target_object_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SetContractChangeItemTargetResponse
 */ export class SetContractChangeItemTargetResponse extends Message {
    static fromBinary(bytes, options) {
        return new SetContractChangeItemTargetResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetContractChangeItemTargetResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetContractChangeItemTargetResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetContractChangeItemTargetResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractChangeItem item = 1;
   */ _define_property(this, "item", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetContractChangeItemTargetResponse, "runtime", proto3);
_define_property(SetContractChangeItemTargetResponse, "typeName", "mono.datagateway.v1.SetContractChangeItemTargetResponse");
_define_property(SetContractChangeItemTargetResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "item",
            kind: "message",
            T: ContractChangeItem
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ContractChangeItemFilter
 */ export class ContractChangeItemFilter extends Message {
    static fromBinary(bytes, options) {
        return new ContractChangeItemFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractChangeItemFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractChangeItemFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractChangeItemFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string change_set_id = 2;
   */ _define_property(this, "changeSetId", ""), /**
   * @generated from field: string change_category = 3;
   */ _define_property(this, "changeCategory", ""), /**
   * @generated from field: string diff_type = 4;
   */ _define_property(this, "diffType", ""), /**
   * @generated from field: string functional_owner = 5;
   */ _define_property(this, "functionalOwner", ""), /**
   * @generated from field: string resolution_state = 6;
   */ _define_property(this, "resolutionState", ""), /**
   * @generated from field: string severity = 7;
   */ _define_property(this, "severity", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractChangeItemFilter, "runtime", proto3);
_define_property(ContractChangeItemFilter, "typeName", "mono.datagateway.v1.ContractChangeItemFilter");
_define_property(ContractChangeItemFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "change_category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "diff_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "functional_owner",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "resolution_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "severity",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListContractChangeItemsRequest
 */ export class ListContractChangeItemsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListContractChangeItemsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListContractChangeItemsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListContractChangeItemsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListContractChangeItemsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractChangeItemFilter filter = 1;
   */ _define_property(this, "filter", void 0), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListContractChangeItemsRequest, "runtime", proto3);
_define_property(ListContractChangeItemsRequest, "typeName", "mono.datagateway.v1.ListContractChangeItemsRequest");
_define_property(ListContractChangeItemsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: ContractChangeItemFilter
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListContractChangeItemsResponse
 */ export class ListContractChangeItemsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListContractChangeItemsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListContractChangeItemsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListContractChangeItemsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListContractChangeItemsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.ContractChangeItem items = 1;
   */ _define_property(this, "items", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListContractChangeItemsResponse, "runtime", proto3);
_define_property(ListContractChangeItemsResponse, "typeName", "mono.datagateway.v1.ListContractChangeItemsResponse");
_define_property(ListContractChangeItemsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "items",
            kind: "message",
            T: ContractChangeItem,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * --- FieldLineage ---
 *
 * @generated from message mono.datagateway.v1.WriteFieldLineageRequest
 */ export class WriteFieldLineageRequest extends Message {
    static fromBinary(bytes, options) {
        return new WriteFieldLineageRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WriteFieldLineageRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WriteFieldLineageRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WriteFieldLineageRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.FieldLineage entry = 1;
   */ _define_property(this, "entry", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(WriteFieldLineageRequest, "runtime", proto3);
_define_property(WriteFieldLineageRequest, "typeName", "mono.datagateway.v1.WriteFieldLineageRequest");
_define_property(WriteFieldLineageRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "entry",
            kind: "message",
            T: FieldLineage
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.WriteFieldLineageResponse
 */ export class WriteFieldLineageResponse extends Message {
    static fromBinary(bytes, options) {
        return new WriteFieldLineageResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WriteFieldLineageResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WriteFieldLineageResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WriteFieldLineageResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.FieldLineage entry = 1;
   */ _define_property(this, "entry", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(WriteFieldLineageResponse, "runtime", proto3);
_define_property(WriteFieldLineageResponse, "typeName", "mono.datagateway.v1.WriteFieldLineageResponse");
_define_property(WriteFieldLineageResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "entry",
            kind: "message",
            T: FieldLineage
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.BulkWriteFieldLineageRequest
 */ export class BulkWriteFieldLineageRequest extends Message {
    static fromBinary(bytes, options) {
        return new BulkWriteFieldLineageRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BulkWriteFieldLineageRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BulkWriteFieldLineageRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BulkWriteFieldLineageRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.FieldLineage entries = 1;
   */ _define_property(this, "entries", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(BulkWriteFieldLineageRequest, "runtime", proto3);
_define_property(BulkWriteFieldLineageRequest, "typeName", "mono.datagateway.v1.BulkWriteFieldLineageRequest");
_define_property(BulkWriteFieldLineageRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "entries",
            kind: "message",
            T: FieldLineage,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.BulkWriteFieldLineageResponse
 */ export class BulkWriteFieldLineageResponse extends Message {
    static fromBinary(bytes, options) {
        return new BulkWriteFieldLineageResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BulkWriteFieldLineageResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BulkWriteFieldLineageResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BulkWriteFieldLineageResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 inserted = 1;
   */ _define_property(this, "inserted", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(BulkWriteFieldLineageResponse, "runtime", proto3);
_define_property(BulkWriteFieldLineageResponse, "typeName", "mono.datagateway.v1.BulkWriteFieldLineageResponse");
_define_property(BulkWriteFieldLineageResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "inserted",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListFieldLineageForFieldRequest
 */ export class ListFieldLineageForFieldRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListFieldLineageForFieldRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListFieldLineageForFieldRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListFieldLineageForFieldRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListFieldLineageForFieldRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string target_object_type = 2;
   */ _define_property(this, "targetObjectType", ""), /**
   * @generated from field: string target_object_id = 3;
   */ _define_property(this, "targetObjectId", ""), /**
   * @generated from field: string target_field_path = 4;
   */ _define_property(this, "targetFieldPath", ""), /**
   * @generated from field: int32 limit = 5;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListFieldLineageForFieldRequest, "runtime", proto3);
_define_property(ListFieldLineageForFieldRequest, "typeName", "mono.datagateway.v1.ListFieldLineageForFieldRequest");
_define_property(ListFieldLineageForFieldRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "target_object_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "target_object_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "target_field_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListFieldLineageForFieldResponse
 */ export class ListFieldLineageForFieldResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListFieldLineageForFieldResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListFieldLineageForFieldResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListFieldLineageForFieldResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListFieldLineageForFieldResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.FieldLineage entries = 1;
   */ _define_property(this, "entries", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListFieldLineageForFieldResponse, "runtime", proto3);
_define_property(ListFieldLineageForFieldResponse, "typeName", "mono.datagateway.v1.ListFieldLineageForFieldResponse");
_define_property(ListFieldLineageForFieldResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "entries",
            kind: "message",
            T: FieldLineage,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListFieldLineageForObjectRequest
 */ export class ListFieldLineageForObjectRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListFieldLineageForObjectRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListFieldLineageForObjectRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListFieldLineageForObjectRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListFieldLineageForObjectRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string target_object_type = 2;
   */ _define_property(this, "targetObjectType", ""), /**
   * @generated from field: string target_object_id = 3;
   */ _define_property(this, "targetObjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListFieldLineageForObjectRequest, "runtime", proto3);
_define_property(ListFieldLineageForObjectRequest, "typeName", "mono.datagateway.v1.ListFieldLineageForObjectRequest");
_define_property(ListFieldLineageForObjectRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "target_object_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "target_object_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListFieldLineageForObjectResponse
 */ export class ListFieldLineageForObjectResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListFieldLineageForObjectResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListFieldLineageForObjectResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListFieldLineageForObjectResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListFieldLineageForObjectResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.FieldLineage entries = 1;
   */ _define_property(this, "entries", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListFieldLineageForObjectResponse, "runtime", proto3);
_define_property(ListFieldLineageForObjectResponse, "typeName", "mono.datagateway.v1.ListFieldLineageForObjectResponse");
_define_property(ListFieldLineageForObjectResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "entries",
            kind: "message",
            T: FieldLineage,
            repeated: true
        }
    ]));
/**
 * --- SourceReference (per-value extraction provenance, Phase 4c-3) ---
 * One row per extracted value; mirrors contractintel.v1.SourceMetadata. Shared
 * by award extraction and modifications (source_kind discriminates).
 *
 * @generated from message mono.datagateway.v1.SourceReference
 */ export class SourceReference extends Message {
    static fromBinary(bytes, options) {
        return new SourceReference().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SourceReference().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SourceReference().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SourceReference, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string target_object_type = 3;
   */ _define_property(this, "targetObjectType", ""), /**
   * @generated from field: string target_object_id = 4;
   */ _define_property(this, "targetObjectId", ""), /**
   * @generated from field: string target_field_path = 5;
   */ _define_property(this, "targetFieldPath", ""), /**
   * @generated from field: string source_artifact_id = 6;
   */ _define_property(this, "sourceArtifactId", ""), /**
   * @generated from field: int32 source_page = 7;
   */ _define_property(this, "sourcePage", 0), /**
   * @generated from field: string source_section = 8;
   */ _define_property(this, "sourceSection", ""), /**
   * @generated from field: string source_quote = 9;
   */ _define_property(this, "sourceQuote", ""), /**
   * @generated from field: string raw_value = 10;
   */ _define_property(this, "rawValue", ""), /**
   * @generated from field: string normalized_value = 11;
   */ _define_property(this, "normalizedValue", ""), /**
   * @generated from field: repeated string extraction_warnings = 12;
   */ _define_property(this, "extractionWarnings", []), /**
   * @generated from field: string extractor_name = 13;
   */ _define_property(this, "extractorName", ""), /**
   * @generated from field: double confidence = 14;
   */ _define_property(this, "confidence", 0), /**
   * UNREVIEWED|APPROVED|REJECTED|CORRECTED|WAIVED|ESCALATED
   *
   * @generated from field: string review_state = 15;
   */ _define_property(this, "reviewState", ""), /**
   * ProposalBaseline|PreAward|FinalContract|Modification|Manual|ReExtraction
   *
   * @generated from field: string source_kind = 16;
   */ _define_property(this, "sourceKind", ""), /**
   * @generated from field: bool current_version_flag = 17;
   */ _define_property(this, "currentVersionFlag", false), /**
   * @generated from field: string superseded_by_reference_id = 18;
   */ _define_property(this, "supersededByReferenceId", ""), /**
   * nullable link to a ContractChangeSet
   *
   * @generated from field: string change_set_id = 19;
   */ _define_property(this, "changeSetId", ""), /**
   * @generated from field: string reviewer = 20;
   */ _define_property(this, "reviewer", ""), /**
   * @generated from field: google.protobuf.Timestamp decided_at = 21;
   */ _define_property(this, "decidedAt", void 0), /**
   * @generated from field: string rationale = 22;
   */ _define_property(this, "rationale", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 23;
   */ _define_property(this, "createdAt", void 0), /**
   * Serialized source span / bounding box (JSON: {blockId,page,bbox{x,y,width,height}}).
   * Carries the page-overlay coordinates extraction produced so the Source
   * Review UI can highlight the exact region, the way the proposal flow does.
   *
   * @generated from field: string source_span = 24;
   */ _define_property(this, "sourceSpan", ""), /**
   * Additive execution-scope provenance (doc 05). Lane B owns persistence.
   * A missing bbox degrades to page/quote; it does not drop the citation.
   *
   * @generated from field: string source_block_id = 25;
   */ _define_property(this, "sourceBlockId", ""), /**
   * @generated from field: string source_artifact_version_id = 26;
   */ _define_property(this, "sourceArtifactVersionId", ""), /**
   * @generated from field: string source_content_sha256 = 27;
   */ _define_property(this, "sourceContentSha256", ""), /**
   * @generated from field: string source_rendition_id = 28;
   */ _define_property(this, "sourceRenditionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SourceReference, "runtime", proto3);
_define_property(SourceReference, "typeName", "mono.datagateway.v1.SourceReference");
_define_property(SourceReference, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "target_object_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "target_object_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "target_field_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "source_artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "source_page",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 8,
            name: "source_section",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "source_quote",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "raw_value",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "normalized_value",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "extraction_warnings",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 13,
            name: "extractor_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 15,
            name: "review_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "source_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "current_version_flag",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 18,
            name: "superseded_by_reference_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "reviewer",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 21,
            name: "decided_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 22,
            name: "rationale",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 23,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 24,
            name: "source_span",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 25,
            name: "source_block_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 26,
            name: "source_artifact_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 27,
            name: "source_content_sha256",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 28,
            name: "source_rendition_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.BulkInsertSourceReferencesRequest
 */ export class BulkInsertSourceReferencesRequest extends Message {
    static fromBinary(bytes, options) {
        return new BulkInsertSourceReferencesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BulkInsertSourceReferencesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BulkInsertSourceReferencesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BulkInsertSourceReferencesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.SourceReference references = 1;
   */ _define_property(this, "references", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(BulkInsertSourceReferencesRequest, "runtime", proto3);
_define_property(BulkInsertSourceReferencesRequest, "typeName", "mono.datagateway.v1.BulkInsertSourceReferencesRequest");
_define_property(BulkInsertSourceReferencesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "references",
            kind: "message",
            T: SourceReference,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.BulkInsertSourceReferencesResponse
 */ export class BulkInsertSourceReferencesResponse extends Message {
    static fromBinary(bytes, options) {
        return new BulkInsertSourceReferencesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BulkInsertSourceReferencesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BulkInsertSourceReferencesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BulkInsertSourceReferencesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 inserted = 1;
   */ _define_property(this, "inserted", 0), /**
   * @generated from field: repeated mono.datagateway.v1.SourceReference references = 2;
   */ _define_property(this, "references", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(BulkInsertSourceReferencesResponse, "runtime", proto3);
_define_property(BulkInsertSourceReferencesResponse, "typeName", "mono.datagateway.v1.BulkInsertSourceReferencesResponse");
_define_property(BulkInsertSourceReferencesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "inserted",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "references",
            kind: "message",
            T: SourceReference,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetSourceReferenceRequest
 */ export class GetSourceReferenceRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetSourceReferenceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetSourceReferenceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetSourceReferenceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetSourceReferenceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetSourceReferenceRequest, "runtime", proto3);
_define_property(GetSourceReferenceRequest, "typeName", "mono.datagateway.v1.GetSourceReferenceRequest");
_define_property(GetSourceReferenceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetSourceReferenceResponse
 */ export class GetSourceReferenceResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetSourceReferenceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetSourceReferenceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetSourceReferenceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetSourceReferenceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.SourceReference reference = 1;
   */ _define_property(this, "reference", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetSourceReferenceResponse, "runtime", proto3);
_define_property(GetSourceReferenceResponse, "typeName", "mono.datagateway.v1.GetSourceReferenceResponse");
_define_property(GetSourceReferenceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "reference",
            kind: "message",
            T: SourceReference
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListSourceReferencesByTargetRequest
 */ export class ListSourceReferencesByTargetRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListSourceReferencesByTargetRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListSourceReferencesByTargetRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListSourceReferencesByTargetRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListSourceReferencesByTargetRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string target_object_type = 2;
   */ _define_property(this, "targetObjectType", ""), /**
   * @generated from field: string target_object_id = 3;
   */ _define_property(this, "targetObjectId", ""), /**
   * @generated from field: bool current_only = 4;
   */ _define_property(this, "currentOnly", false), /**
   * When set, target_object_id MUST be empty (the two are mutually
   * exclusive) and every ref whose id starts with this prefix is returned
   * (e.g. "{programId}/" fetches a whole program's PwsObligation refs in one
   * query instead of one per section).
   *
   * @generated from field: string target_object_id_prefix = 5;
   */ _define_property(this, "targetObjectIdPrefix", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListSourceReferencesByTargetRequest, "runtime", proto3);
_define_property(ListSourceReferencesByTargetRequest, "typeName", "mono.datagateway.v1.ListSourceReferencesByTargetRequest");
_define_property(ListSourceReferencesByTargetRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "target_object_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "target_object_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "current_only",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "target_object_id_prefix",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListSourceReferencesByArtifactRequest
 */ export class ListSourceReferencesByArtifactRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListSourceReferencesByArtifactRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListSourceReferencesByArtifactRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListSourceReferencesByArtifactRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListSourceReferencesByArtifactRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string source_artifact_id = 2;
   */ _define_property(this, "sourceArtifactId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListSourceReferencesByArtifactRequest, "runtime", proto3);
_define_property(ListSourceReferencesByArtifactRequest, "typeName", "mono.datagateway.v1.ListSourceReferencesByArtifactRequest");
_define_property(ListSourceReferencesByArtifactRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "source_artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListSourceReferencesByChangeSetRequest
 */ export class ListSourceReferencesByChangeSetRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListSourceReferencesByChangeSetRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListSourceReferencesByChangeSetRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListSourceReferencesByChangeSetRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListSourceReferencesByChangeSetRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string change_set_id = 2;
   */ _define_property(this, "changeSetId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListSourceReferencesByChangeSetRequest, "runtime", proto3);
_define_property(ListSourceReferencesByChangeSetRequest, "typeName", "mono.datagateway.v1.ListSourceReferencesByChangeSetRequest");
_define_property(ListSourceReferencesByChangeSetRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListSourceReferencesByTargetResponse
 */ export class ListSourceReferencesByTargetResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListSourceReferencesByTargetResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListSourceReferencesByTargetResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListSourceReferencesByTargetResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListSourceReferencesByTargetResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.SourceReference references = 1;
   */ _define_property(this, "references", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListSourceReferencesByTargetResponse, "runtime", proto3);
_define_property(ListSourceReferencesByTargetResponse, "typeName", "mono.datagateway.v1.ListSourceReferencesByTargetResponse");
_define_property(ListSourceReferencesByTargetResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "references",
            kind: "message",
            T: SourceReference,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListSourceReferencesByArtifactResponse
 */ export class ListSourceReferencesByArtifactResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListSourceReferencesByArtifactResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListSourceReferencesByArtifactResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListSourceReferencesByArtifactResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListSourceReferencesByArtifactResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.SourceReference references = 1;
   */ _define_property(this, "references", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListSourceReferencesByArtifactResponse, "runtime", proto3);
_define_property(ListSourceReferencesByArtifactResponse, "typeName", "mono.datagateway.v1.ListSourceReferencesByArtifactResponse");
_define_property(ListSourceReferencesByArtifactResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "references",
            kind: "message",
            T: SourceReference,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListSourceReferencesByChangeSetResponse
 */ export class ListSourceReferencesByChangeSetResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListSourceReferencesByChangeSetResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListSourceReferencesByChangeSetResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListSourceReferencesByChangeSetResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListSourceReferencesByChangeSetResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.SourceReference references = 1;
   */ _define_property(this, "references", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListSourceReferencesByChangeSetResponse, "runtime", proto3);
_define_property(ListSourceReferencesByChangeSetResponse, "typeName", "mono.datagateway.v1.ListSourceReferencesByChangeSetResponse");
_define_property(ListSourceReferencesByChangeSetResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "references",
            kind: "message",
            T: SourceReference,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateSourceReferenceReviewStateRequest
 */ export class UpdateSourceReferenceReviewStateRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateSourceReferenceReviewStateRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateSourceReferenceReviewStateRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateSourceReferenceReviewStateRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateSourceReferenceReviewStateRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string review_state = 3;
   */ _define_property(this, "reviewState", ""), /**
   * @generated from field: string reviewer = 4;
   */ _define_property(this, "reviewer", ""), /**
   * @generated from field: string rationale = 5;
   */ _define_property(this, "rationale", ""), /**
   * optional corrected value (review_state=CORRECTED)
   *
   * @generated from field: string normalized_value = 6;
   */ _define_property(this, "normalizedValue", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateSourceReferenceReviewStateRequest, "runtime", proto3);
_define_property(UpdateSourceReferenceReviewStateRequest, "typeName", "mono.datagateway.v1.UpdateSourceReferenceReviewStateRequest");
_define_property(UpdateSourceReferenceReviewStateRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "review_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "reviewer",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "rationale",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "normalized_value",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateSourceReferenceReviewStateResponse
 */ export class UpdateSourceReferenceReviewStateResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateSourceReferenceReviewStateResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateSourceReferenceReviewStateResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateSourceReferenceReviewStateResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateSourceReferenceReviewStateResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.SourceReference reference = 1;
   */ _define_property(this, "reference", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateSourceReferenceReviewStateResponse, "runtime", proto3);
_define_property(UpdateSourceReferenceReviewStateResponse, "typeName", "mono.datagateway.v1.UpdateSourceReferenceReviewStateResponse");
_define_property(UpdateSourceReferenceReviewStateResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "reference",
            kind: "message",
            T: SourceReference
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.MarkSourceReferenceSupersededRequest
 */ export class MarkSourceReferenceSupersededRequest extends Message {
    static fromBinary(bytes, options) {
        return new MarkSourceReferenceSupersededRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MarkSourceReferenceSupersededRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MarkSourceReferenceSupersededRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MarkSourceReferenceSupersededRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string superseded_by_reference_id = 3;
   */ _define_property(this, "supersededByReferenceId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(MarkSourceReferenceSupersededRequest, "runtime", proto3);
_define_property(MarkSourceReferenceSupersededRequest, "typeName", "mono.datagateway.v1.MarkSourceReferenceSupersededRequest");
_define_property(MarkSourceReferenceSupersededRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "superseded_by_reference_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.MarkSourceReferenceSupersededResponse
 */ export class MarkSourceReferenceSupersededResponse extends Message {
    static fromBinary(bytes, options) {
        return new MarkSourceReferenceSupersededResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MarkSourceReferenceSupersededResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MarkSourceReferenceSupersededResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MarkSourceReferenceSupersededResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.SourceReference reference = 1;
   */ _define_property(this, "reference", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(MarkSourceReferenceSupersededResponse, "runtime", proto3);
_define_property(MarkSourceReferenceSupersededResponse, "typeName", "mono.datagateway.v1.MarkSourceReferenceSupersededResponse");
_define_property(MarkSourceReferenceSupersededResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "reference",
            kind: "message",
            T: SourceReference
        }
    ]));
/**
 * --- ContractActivationGate ---
 *
 * @generated from message mono.datagateway.v1.CreateContractActivationGateRequest
 */ export class CreateContractActivationGateRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateContractActivationGateRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateContractActivationGateRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateContractActivationGateRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateContractActivationGateRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string contract_project_id = 2;
   */ _define_property(this, "contractProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateContractActivationGateRequest, "runtime", proto3);
_define_property(CreateContractActivationGateRequest, "typeName", "mono.datagateway.v1.CreateContractActivationGateRequest");
_define_property(CreateContractActivationGateRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "contract_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateContractActivationGateResponse
 */ export class CreateContractActivationGateResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateContractActivationGateResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateContractActivationGateResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateContractActivationGateResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateContractActivationGateResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractActivationGate gate = 1;
   */ _define_property(this, "gate", void 0), /**
   * @generated from field: repeated mono.datagateway.v1.ContractActivationGateItem items = 2;
   */ _define_property(this, "items", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateContractActivationGateResponse, "runtime", proto3);
_define_property(CreateContractActivationGateResponse, "typeName", "mono.datagateway.v1.CreateContractActivationGateResponse");
_define_property(CreateContractActivationGateResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "gate",
            kind: "message",
            T: ContractActivationGate
        },
        {
            no: 2,
            name: "items",
            kind: "message",
            T: ContractActivationGateItem,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetContractActivationGateRequest
 */ export class GetContractActivationGateRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetContractActivationGateRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetContractActivationGateRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetContractActivationGateRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetContractActivationGateRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string contract_project_id = 1;
   */ _define_property(this, "contractProjectId", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetContractActivationGateRequest, "runtime", proto3);
_define_property(GetContractActivationGateRequest, "typeName", "mono.datagateway.v1.GetContractActivationGateRequest");
_define_property(GetContractActivationGateRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contract_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetContractActivationGateResponse
 */ export class GetContractActivationGateResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetContractActivationGateResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetContractActivationGateResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetContractActivationGateResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetContractActivationGateResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractActivationGate gate = 1;
   */ _define_property(this, "gate", void 0), /**
   * @generated from field: repeated mono.datagateway.v1.ContractActivationGateItem items = 2;
   */ _define_property(this, "items", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetContractActivationGateResponse, "runtime", proto3);
_define_property(GetContractActivationGateResponse, "typeName", "mono.datagateway.v1.GetContractActivationGateResponse");
_define_property(GetContractActivationGateResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "gate",
            kind: "message",
            T: ContractActivationGate
        },
        {
            no: 2,
            name: "items",
            kind: "message",
            T: ContractActivationGateItem,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateContractActivationGateItemRequest
 */ export class UpdateContractActivationGateItemRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateContractActivationGateItemRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateContractActivationGateItemRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateContractActivationGateItemRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateContractActivationGateItemRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string contract_project_id = 1;
   */ _define_property(this, "contractProjectId", ""), /**
   * @generated from field: string item_key = 2;
   */ _define_property(this, "itemKey", ""), /**
   * @generated from field: string state = 3;
   */ _define_property(this, "state", ""), /**
   * @generated from field: string reason = 4;
   */ _define_property(this, "reason", ""), /**
   * @generated from field: string decided_by = 5;
   */ _define_property(this, "decidedBy", ""), /**
   * @generated from field: string tenant_id = 6;
   */ _define_property(this, "tenantId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateContractActivationGateItemRequest, "runtime", proto3);
_define_property(UpdateContractActivationGateItemRequest, "typeName", "mono.datagateway.v1.UpdateContractActivationGateItemRequest");
_define_property(UpdateContractActivationGateItemRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contract_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "item_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "decided_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateContractActivationGateItemResponse
 */ export class UpdateContractActivationGateItemResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateContractActivationGateItemResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateContractActivationGateItemResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateContractActivationGateItemResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateContractActivationGateItemResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractActivationGateItem item = 1;
   */ _define_property(this, "item", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateContractActivationGateItemResponse, "runtime", proto3);
_define_property(UpdateContractActivationGateItemResponse, "typeName", "mono.datagateway.v1.UpdateContractActivationGateItemResponse");
_define_property(UpdateContractActivationGateItemResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "item",
            kind: "message",
            T: ContractActivationGateItem
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ActivateContractGateRequest
 */ export class ActivateContractGateRequest extends Message {
    static fromBinary(bytes, options) {
        return new ActivateContractGateRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ActivateContractGateRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ActivateContractGateRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ActivateContractGateRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string contract_project_id = 1;
   */ _define_property(this, "contractProjectId", ""), /**
   * @generated from field: string activated_by = 2;
   */ _define_property(this, "activatedBy", ""), /**
   * @generated from field: string tenant_id = 3;
   */ _define_property(this, "tenantId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ActivateContractGateRequest, "runtime", proto3);
_define_property(ActivateContractGateRequest, "typeName", "mono.datagateway.v1.ActivateContractGateRequest");
_define_property(ActivateContractGateRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contract_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "activated_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ActivateContractGateResponse
 */ export class ActivateContractGateResponse extends Message {
    static fromBinary(bytes, options) {
        return new ActivateContractGateResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ActivateContractGateResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ActivateContractGateResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ActivateContractGateResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractActivationGate gate = 1;
   */ _define_property(this, "gate", void 0), /**
   * @generated from field: repeated string violations = 2;
   */ _define_property(this, "violations", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ActivateContractGateResponse, "runtime", proto3);
_define_property(ActivateContractGateResponse, "typeName", "mono.datagateway.v1.ActivateContractGateResponse");
_define_property(ActivateContractGateResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "gate",
            kind: "message",
            T: ContractActivationGate
        },
        {
            no: 2,
            name: "violations",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * --- DeliverableEvidence ---
 *
 * @generated from message mono.datagateway.v1.RecordDeliverableEvidenceRequest
 */ export class RecordDeliverableEvidenceRequest extends Message {
    static fromBinary(bytes, options) {
        return new RecordDeliverableEvidenceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordDeliverableEvidenceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordDeliverableEvidenceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordDeliverableEvidenceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.DeliverableEvidence evidence = 1;
   */ _define_property(this, "evidence", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordDeliverableEvidenceRequest, "runtime", proto3);
_define_property(RecordDeliverableEvidenceRequest, "typeName", "mono.datagateway.v1.RecordDeliverableEvidenceRequest");
_define_property(RecordDeliverableEvidenceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "evidence",
            kind: "message",
            T: DeliverableEvidence
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RecordDeliverableEvidenceResponse
 */ export class RecordDeliverableEvidenceResponse extends Message {
    static fromBinary(bytes, options) {
        return new RecordDeliverableEvidenceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordDeliverableEvidenceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordDeliverableEvidenceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordDeliverableEvidenceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.DeliverableEvidence evidence = 1;
   */ _define_property(this, "evidence", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordDeliverableEvidenceResponse, "runtime", proto3);
_define_property(RecordDeliverableEvidenceResponse, "typeName", "mono.datagateway.v1.RecordDeliverableEvidenceResponse");
_define_property(RecordDeliverableEvidenceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "evidence",
            kind: "message",
            T: DeliverableEvidence
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetDeliverableEvidenceRequest
 */ export class GetDeliverableEvidenceRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetDeliverableEvidenceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetDeliverableEvidenceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetDeliverableEvidenceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetDeliverableEvidenceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetDeliverableEvidenceRequest, "runtime", proto3);
_define_property(GetDeliverableEvidenceRequest, "typeName", "mono.datagateway.v1.GetDeliverableEvidenceRequest");
_define_property(GetDeliverableEvidenceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetDeliverableEvidenceResponse
 */ export class GetDeliverableEvidenceResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetDeliverableEvidenceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetDeliverableEvidenceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetDeliverableEvidenceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetDeliverableEvidenceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.DeliverableEvidence evidence = 1;
   */ _define_property(this, "evidence", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetDeliverableEvidenceResponse, "runtime", proto3);
_define_property(GetDeliverableEvidenceResponse, "typeName", "mono.datagateway.v1.GetDeliverableEvidenceResponse");
_define_property(GetDeliverableEvidenceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "evidence",
            kind: "message",
            T: DeliverableEvidence
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListDeliverableEvidenceByTaskRequest
 */ export class ListDeliverableEvidenceByTaskRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListDeliverableEvidenceByTaskRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListDeliverableEvidenceByTaskRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListDeliverableEvidenceByTaskRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListDeliverableEvidenceByTaskRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_task_id = 2;
   */ _define_property(this, "programTaskId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListDeliverableEvidenceByTaskRequest, "runtime", proto3);
_define_property(ListDeliverableEvidenceByTaskRequest, "typeName", "mono.datagateway.v1.ListDeliverableEvidenceByTaskRequest");
_define_property(ListDeliverableEvidenceByTaskRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_task_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListDeliverableEvidenceByTaskResponse
 */ export class ListDeliverableEvidenceByTaskResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListDeliverableEvidenceByTaskResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListDeliverableEvidenceByTaskResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListDeliverableEvidenceByTaskResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListDeliverableEvidenceByTaskResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.DeliverableEvidence evidence = 1;
   */ _define_property(this, "evidence", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListDeliverableEvidenceByTaskResponse, "runtime", proto3);
_define_property(ListDeliverableEvidenceByTaskResponse, "typeName", "mono.datagateway.v1.ListDeliverableEvidenceByTaskResponse");
_define_property(ListDeliverableEvidenceByTaskResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "evidence",
            kind: "message",
            T: DeliverableEvidence,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ValidateDeliverableEvidenceRequest
 */ export class ValidateDeliverableEvidenceRequest extends Message {
    static fromBinary(bytes, options) {
        return new ValidateDeliverableEvidenceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ValidateDeliverableEvidenceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ValidateDeliverableEvidenceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ValidateDeliverableEvidenceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string validated_by = 2;
   */ _define_property(this, "validatedBy", ""), /**
   * @generated from field: string audit_event_id = 3;
   */ _define_property(this, "auditEventId", ""), /**
   * @generated from field: string tenant_id = 4;
   */ _define_property(this, "tenantId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ValidateDeliverableEvidenceRequest, "runtime", proto3);
_define_property(ValidateDeliverableEvidenceRequest, "typeName", "mono.datagateway.v1.ValidateDeliverableEvidenceRequest");
_define_property(ValidateDeliverableEvidenceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "validated_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "audit_event_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ValidateDeliverableEvidenceResponse
 */ export class ValidateDeliverableEvidenceResponse extends Message {
    static fromBinary(bytes, options) {
        return new ValidateDeliverableEvidenceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ValidateDeliverableEvidenceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ValidateDeliverableEvidenceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ValidateDeliverableEvidenceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.DeliverableEvidence evidence = 1;
   */ _define_property(this, "evidence", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ValidateDeliverableEvidenceResponse, "runtime", proto3);
_define_property(ValidateDeliverableEvidenceResponse, "typeName", "mono.datagateway.v1.ValidateDeliverableEvidenceResponse");
_define_property(ValidateDeliverableEvidenceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "evidence",
            kind: "message",
            T: DeliverableEvidence
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RejectDeliverableEvidenceRequest
 */ export class RejectDeliverableEvidenceRequest extends Message {
    static fromBinary(bytes, options) {
        return new RejectDeliverableEvidenceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RejectDeliverableEvidenceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RejectDeliverableEvidenceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RejectDeliverableEvidenceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string rejected_by = 2;
   */ _define_property(this, "rejectedBy", ""), /**
   * @generated from field: string reason = 3;
   */ _define_property(this, "reason", ""), /**
   * @generated from field: string audit_event_id = 4;
   */ _define_property(this, "auditEventId", ""), /**
   * @generated from field: string tenant_id = 5;
   */ _define_property(this, "tenantId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RejectDeliverableEvidenceRequest, "runtime", proto3);
_define_property(RejectDeliverableEvidenceRequest, "typeName", "mono.datagateway.v1.RejectDeliverableEvidenceRequest");
_define_property(RejectDeliverableEvidenceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "rejected_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "audit_event_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RejectDeliverableEvidenceResponse
 */ export class RejectDeliverableEvidenceResponse extends Message {
    static fromBinary(bytes, options) {
        return new RejectDeliverableEvidenceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RejectDeliverableEvidenceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RejectDeliverableEvidenceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RejectDeliverableEvidenceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.DeliverableEvidence evidence = 1;
   */ _define_property(this, "evidence", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RejectDeliverableEvidenceResponse, "runtime", proto3);
_define_property(RejectDeliverableEvidenceResponse, "typeName", "mono.datagateway.v1.RejectDeliverableEvidenceResponse");
_define_property(RejectDeliverableEvidenceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "evidence",
            kind: "message",
            T: DeliverableEvidence
        }
    ]));
/**
 * UpdateDeliverableEvidenceRequest uses proto3 field presence (`optional`)
 * on every mutable field so a caller that omits a field leaves the
 * existing column untouched — the repository only writes fields that are
 * actually set, never all-or-nothing. This is what makes "update notes
 * only, leave customer_acceptance_status/everything else intact" hold.
 *
 * @generated from message mono.datagateway.v1.UpdateDeliverableEvidenceRequest
 */ export class UpdateDeliverableEvidenceRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateDeliverableEvidenceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateDeliverableEvidenceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateDeliverableEvidenceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateDeliverableEvidenceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: optional string customer_acceptance_status = 3;
   */ _define_property(this, "customerAcceptanceStatus", void 0), /**
   * @generated from field: optional string delivery_notes = 4;
   */ _define_property(this, "deliveryNotes", void 0), /**
   * @generated from field: optional string submitted_to_contact_id = 5;
   */ _define_property(this, "submittedToContactId", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateDeliverableEvidenceRequest, "runtime", proto3);
_define_property(UpdateDeliverableEvidenceRequest, "typeName", "mono.datagateway.v1.UpdateDeliverableEvidenceRequest");
_define_property(UpdateDeliverableEvidenceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "customer_acceptance_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 4,
            name: "delivery_notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 5,
            name: "submitted_to_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateDeliverableEvidenceResponse
 */ export class UpdateDeliverableEvidenceResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateDeliverableEvidenceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateDeliverableEvidenceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateDeliverableEvidenceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateDeliverableEvidenceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.DeliverableEvidence evidence = 1;
   */ _define_property(this, "evidence", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateDeliverableEvidenceResponse, "runtime", proto3);
_define_property(UpdateDeliverableEvidenceResponse, "typeName", "mono.datagateway.v1.UpdateDeliverableEvidenceResponse");
_define_property(UpdateDeliverableEvidenceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "evidence",
            kind: "message",
            T: DeliverableEvidence
        }
    ]));
/**
 * --- ExternalArtifactReference ---
 *
 * @generated from message mono.datagateway.v1.CreateExternalArtifactReferenceRequest
 */ export class CreateExternalArtifactReferenceRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateExternalArtifactReferenceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateExternalArtifactReferenceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateExternalArtifactReferenceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateExternalArtifactReferenceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ExternalArtifactReference reference = 1;
   */ _define_property(this, "reference", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateExternalArtifactReferenceRequest, "runtime", proto3);
_define_property(CreateExternalArtifactReferenceRequest, "typeName", "mono.datagateway.v1.CreateExternalArtifactReferenceRequest");
_define_property(CreateExternalArtifactReferenceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "reference",
            kind: "message",
            T: ExternalArtifactReference
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateExternalArtifactReferenceResponse
 */ export class CreateExternalArtifactReferenceResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateExternalArtifactReferenceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateExternalArtifactReferenceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateExternalArtifactReferenceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateExternalArtifactReferenceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ExternalArtifactReference reference = 1;
   */ _define_property(this, "reference", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateExternalArtifactReferenceResponse, "runtime", proto3);
_define_property(CreateExternalArtifactReferenceResponse, "typeName", "mono.datagateway.v1.CreateExternalArtifactReferenceResponse");
_define_property(CreateExternalArtifactReferenceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "reference",
            kind: "message",
            T: ExternalArtifactReference
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetExternalArtifactReferenceRequest
 */ export class GetExternalArtifactReferenceRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetExternalArtifactReferenceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetExternalArtifactReferenceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetExternalArtifactReferenceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetExternalArtifactReferenceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetExternalArtifactReferenceRequest, "runtime", proto3);
_define_property(GetExternalArtifactReferenceRequest, "typeName", "mono.datagateway.v1.GetExternalArtifactReferenceRequest");
_define_property(GetExternalArtifactReferenceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetExternalArtifactReferenceResponse
 */ export class GetExternalArtifactReferenceResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetExternalArtifactReferenceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetExternalArtifactReferenceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetExternalArtifactReferenceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetExternalArtifactReferenceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ExternalArtifactReference reference = 1;
   */ _define_property(this, "reference", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetExternalArtifactReferenceResponse, "runtime", proto3);
_define_property(GetExternalArtifactReferenceResponse, "typeName", "mono.datagateway.v1.GetExternalArtifactReferenceResponse");
_define_property(GetExternalArtifactReferenceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "reference",
            kind: "message",
            T: ExternalArtifactReference
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.LinkExternalArtifactSnapshotRequest
 */ export class LinkExternalArtifactSnapshotRequest extends Message {
    static fromBinary(bytes, options) {
        return new LinkExternalArtifactSnapshotRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LinkExternalArtifactSnapshotRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LinkExternalArtifactSnapshotRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LinkExternalArtifactSnapshotRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string captured_snapshot_artifact_id = 2;
   */ _define_property(this, "capturedSnapshotArtifactId", ""), /**
   * @generated from field: string captured_by = 3;
   */ _define_property(this, "capturedBy", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LinkExternalArtifactSnapshotRequest, "runtime", proto3);
_define_property(LinkExternalArtifactSnapshotRequest, "typeName", "mono.datagateway.v1.LinkExternalArtifactSnapshotRequest");
_define_property(LinkExternalArtifactSnapshotRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "captured_snapshot_artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "captured_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.LinkExternalArtifactSnapshotResponse
 */ export class LinkExternalArtifactSnapshotResponse extends Message {
    static fromBinary(bytes, options) {
        return new LinkExternalArtifactSnapshotResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LinkExternalArtifactSnapshotResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LinkExternalArtifactSnapshotResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LinkExternalArtifactSnapshotResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ExternalArtifactReference reference = 1;
   */ _define_property(this, "reference", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(LinkExternalArtifactSnapshotResponse, "runtime", proto3);
_define_property(LinkExternalArtifactSnapshotResponse, "typeName", "mono.datagateway.v1.LinkExternalArtifactSnapshotResponse");
_define_property(LinkExternalArtifactSnapshotResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "reference",
            kind: "message",
            T: ExternalArtifactReference
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ExternalArtifactReferenceFilter
 */ export class ExternalArtifactReferenceFilter extends Message {
    static fromBinary(bytes, options) {
        return new ExternalArtifactReferenceFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExternalArtifactReferenceFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExternalArtifactReferenceFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExternalArtifactReferenceFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string source_system = 2;
   */ _define_property(this, "sourceSystem", ""), /**
   * @generated from field: string linked_object_type = 3;
   */ _define_property(this, "linkedObjectType", ""), /**
   * @generated from field: string linked_object_id = 4;
   */ _define_property(this, "linkedObjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExternalArtifactReferenceFilter, "runtime", proto3);
_define_property(ExternalArtifactReferenceFilter, "typeName", "mono.datagateway.v1.ExternalArtifactReferenceFilter");
_define_property(ExternalArtifactReferenceFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "source_system",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "linked_object_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "linked_object_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListExternalArtifactReferencesRequest
 */ export class ListExternalArtifactReferencesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListExternalArtifactReferencesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListExternalArtifactReferencesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListExternalArtifactReferencesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListExternalArtifactReferencesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ExternalArtifactReferenceFilter filter = 1;
   */ _define_property(this, "filter", void 0), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListExternalArtifactReferencesRequest, "runtime", proto3);
_define_property(ListExternalArtifactReferencesRequest, "typeName", "mono.datagateway.v1.ListExternalArtifactReferencesRequest");
_define_property(ListExternalArtifactReferencesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: ExternalArtifactReferenceFilter
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListExternalArtifactReferencesResponse
 */ export class ListExternalArtifactReferencesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListExternalArtifactReferencesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListExternalArtifactReferencesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListExternalArtifactReferencesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListExternalArtifactReferencesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.ExternalArtifactReference references = 1;
   */ _define_property(this, "references", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListExternalArtifactReferencesResponse, "runtime", proto3);
_define_property(ListExternalArtifactReferencesResponse, "typeName", "mono.datagateway.v1.ListExternalArtifactReferencesResponse");
_define_property(ListExternalArtifactReferencesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "references",
            kind: "message",
            T: ExternalArtifactReference,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * RecordPricingSheetRequest describes one uploaded sheet.
 *
 * Upsert by (tenant, artifact): a re-read of the same artifact updates the row it
 * already has rather than minting a second generation, because a re-read is the
 * same document read again — not a new publication.
 *
 * @generated from message mono.datagateway.v1.RecordPricingSheetRequest
 */ export class RecordPricingSheetRequest extends Message {
    static fromBinary(bytes, options) {
        return new RecordPricingSheetRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordPricingSheetRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordPricingSheetRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordPricingSheetRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string contract_vehicle_id = 2;
   */ _define_property(this, "contractVehicleId", ""), /**
   * COMPANY or GOVERNMENT — who PUBLISHED it, never what a given row inside it is
   * about. One artifact can carry vehicle-standard categories and per-company
   * rates together, so a row's company attribution stays on its change item.
   *
   * @generated from field: string issuer_kind = 3;
   */ _define_property(this, "issuerKind", ""), /**
   * @generated from field: string company_profile_id = 4;
   */ _define_property(this, "companyProfileId", ""), /**
   * @generated from field: string artifact_id = 5;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: string source_filename = 6;
   */ _define_property(this, "sourceFilename", ""), /**
   * @generated from field: string mime_type = 7;
   */ _define_property(this, "mimeType", ""), /**
   * The review this sheet produced. Empty when the parse failed, which is a
   * recorded upload with an error rather than a lost file.
   *
   * @generated from field: string change_set_id = 8;
   */ _define_property(this, "changeSetId", ""), /**
   * The sheet's own words about itself.
   *
   * @generated from field: string title = 9;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string period_span_text = 10;
   */ _define_property(this, "periodSpanText", ""), /**
   * PENDING | PARSED | FAILED, and the reason when it failed.
   *
   * @generated from field: string parse_status = 11;
   */ _define_property(this, "parseStatus", ""), /**
   * @generated from field: string parse_error = 12;
   */ _define_property(this, "parseError", ""), /**
   * @generated from field: int32 row_count = 13;
   */ _define_property(this, "rowCount", 0), /**
   * @generated from field: string created_by = 14;
   */ _define_property(this, "createdBy", ""), /**
   * The document's education/experience SUBSTITUTION rule — one rule governing
   * every category in the sheet. Verbatim text, plus where on the page it was
   * read from so a reviewer can check it. The parsed grid is derived server-side.
   *
   * @generated from field: string qualification_substitution_text = 15;
   */ _define_property(this, "qualificationSubstitutionText", ""), /**
   * @generated from field: string qualification_substitution_block_id = 16;
   */ _define_property(this, "qualificationSubstitutionBlockId", ""), /**
   * Provenance, all optional: where the bytes were published, the page that
   * linked them, when they were fetched, and their lowercase hex SHA-256.
   * Sparse on update — an empty field never blanks a stored value.
   *
   * @generated from field: string source_document_url = 17;
   */ _define_property(this, "sourceDocumentUrl", ""), /**
   * @generated from field: string source_page_url = 18;
   */ _define_property(this, "sourcePageUrl", ""), /**
   * @generated from field: google.protobuf.Timestamp retrieved_at = 19;
   */ _define_property(this, "retrievedAt", void 0), /**
   * @generated from field: string source_sha256 = 20;
   */ _define_property(this, "sourceSha256", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordPricingSheetRequest, "runtime", proto3);
_define_property(RecordPricingSheetRequest, "typeName", "mono.datagateway.v1.RecordPricingSheetRequest");
_define_property(RecordPricingSheetRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "contract_vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "issuer_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "source_filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "mime_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "period_span_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "parse_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "parse_error",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "row_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 14,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "qualification_substitution_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "qualification_substitution_block_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "source_document_url",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "source_page_url",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "retrieved_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 20,
            name: "source_sha256",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RecordPricingSheetResponse
 */ export class RecordPricingSheetResponse extends Message {
    static fromBinary(bytes, options) {
        return new RecordPricingSheetResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordPricingSheetResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordPricingSheetResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordPricingSheetResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: int32 generation = 2;
   */ _define_property(this, "generation", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordPricingSheetResponse, "runtime", proto3);
_define_property(RecordPricingSheetResponse, "typeName", "mono.datagateway.v1.RecordPricingSheetResponse");
_define_property(RecordPricingSheetResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "generation",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * One recorded pricing sheet DOCUMENT (a row of delivery.pricing_sheet_generations),
 * with the vehicle's and company's names joined so a reader does not need a
 * second round trip to say which sheet this is.
 *
 * @generated from message mono.datagateway.v1.PricingSheetGeneration
 */ export class PricingSheetGeneration extends Message {
    static fromBinary(bytes, options) {
        return new PricingSheetGeneration().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PricingSheetGeneration().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PricingSheetGeneration().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PricingSheetGeneration, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string contract_vehicle_id = 3;
   */ _define_property(this, "contractVehicleId", ""), /**
   * @generated from field: string contract_vehicle_name = 4;
   */ _define_property(this, "contractVehicleName", ""), /**
   * COMPANY | GOVERNMENT
   *
   * @generated from field: string issuer_kind = 5;
   */ _define_property(this, "issuerKind", ""), /**
   * Empty for a GOVERNMENT (vehicle-wide) sheet.
   *
   * @generated from field: string company_profile_id = 6;
   */ _define_property(this, "companyProfileId", ""), /**
   * @generated from field: string company_profile_name = 7;
   */ _define_property(this, "companyProfileName", ""), /**
   * @generated from field: string artifact_id = 8;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: string source_filename = 9;
   */ _define_property(this, "sourceFilename", ""), /**
   * @generated from field: string mime_type = 10;
   */ _define_property(this, "mimeType", ""), /**
   * @generated from field: string change_set_id = 11;
   */ _define_property(this, "changeSetId", ""), /**
   * @generated from field: string title = 12;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string parse_status = 13;
   */ _define_property(this, "parseStatus", ""), /**
   * @generated from field: string parse_error = 14;
   */ _define_property(this, "parseError", ""), /**
   * @generated from field: int32 row_count = 15;
   */ _define_property(this, "rowCount", 0), /**
   * @generated from field: int32 generation = 16;
   */ _define_property(this, "generation", 0), /**
   * Set once a newer upload replaced this generation.
   *
   * @generated from field: string superseded_by_id = 17;
   */ _define_property(this, "supersededById", ""), /**
   * @generated from field: string source_document_url = 18;
   */ _define_property(this, "sourceDocumentUrl", ""), /**
   * @generated from field: string source_page_url = 19;
   */ _define_property(this, "sourcePageUrl", ""), /**
   * @generated from field: google.protobuf.Timestamp retrieved_at = 20;
   */ _define_property(this, "retrievedAt", void 0), /**
   * @generated from field: string source_sha256 = 21;
   */ _define_property(this, "sourceSha256", ""), /**
   * @generated from field: string vehicle_pool = 22;
   */ _define_property(this, "vehiclePool", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 23;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: string created_by = 24;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: google.protobuf.Timestamp effective_from = 25;
   */ _define_property(this, "effectiveFrom", void 0), /**
   * @generated from field: google.protobuf.Timestamp effective_to = 26;
   */ _define_property(this, "effectiveTo", void 0), /**
   * @generated from field: string period_span_text = 27;
   */ _define_property(this, "periodSpanText", ""), /**
   * REG-26: PENDING rate period coercions filed against this sheet.
   *
   * @generated from field: int32 pending_period_decisions = 28;
   */ _define_property(this, "pendingPeriodDecisions", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PricingSheetGeneration, "runtime", proto3);
_define_property(PricingSheetGeneration, "typeName", "mono.datagateway.v1.PricingSheetGeneration");
_define_property(PricingSheetGeneration, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "contract_vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "contract_vehicle_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "issuer_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "company_profile_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "source_filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "mime_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "parse_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "parse_error",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "row_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 16,
            name: "generation",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 17,
            name: "superseded_by_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "source_document_url",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "source_page_url",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "retrieved_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 21,
            name: "source_sha256",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 22,
            name: "vehicle_pool",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 23,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 24,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 25,
            name: "effective_from",
            kind: "message",
            T: Timestamp
        },
        {
            no: 26,
            name: "effective_to",
            kind: "message",
            T: Timestamp
        },
        {
            no: 27,
            name: "period_span_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 28,
            name: "pending_period_decisions",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListPricingSheetGenerationsRequest
 */ export class ListPricingSheetGenerationsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListPricingSheetGenerationsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPricingSheetGenerationsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPricingSheetGenerationsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPricingSheetGenerationsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string contract_vehicle_id = 2;
   */ _define_property(this, "contractVehicleId", ""), /**
   * @generated from field: string company_profile_id = 3;
   */ _define_property(this, "companyProfileId", ""), /**
   * @generated from field: string change_set_id = 4;
   */ _define_property(this, "changeSetId", ""), /**
   * @generated from field: string artifact_id = 5;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: string source_sha256 = 6;
   */ _define_property(this, "sourceSha256", ""), /**
   * Off by default: the list answers "what is the current sheet".
   *
   * @generated from field: bool include_superseded = 7;
   */ _define_property(this, "includeSuperseded", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListPricingSheetGenerationsRequest, "runtime", proto3);
_define_property(ListPricingSheetGenerationsRequest, "typeName", "mono.datagateway.v1.ListPricingSheetGenerationsRequest");
_define_property(ListPricingSheetGenerationsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "contract_vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "source_sha256",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "include_superseded",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListPricingSheetGenerationsResponse
 */ export class ListPricingSheetGenerationsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListPricingSheetGenerationsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPricingSheetGenerationsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPricingSheetGenerationsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPricingSheetGenerationsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.PricingSheetGeneration generations = 1;
   */ _define_property(this, "generations", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListPricingSheetGenerationsResponse, "runtime", proto3);
_define_property(ListPricingSheetGenerationsResponse, "typeName", "mono.datagateway.v1.ListPricingSheetGenerationsResponse");
_define_property(ListPricingSheetGenerationsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "generations",
            kind: "message",
            T: PricingSheetGeneration,
            repeated: true
        }
    ]));
/**
 * REG-26: record the sheet's contract start (writes effective_from) so
 * "Contract year" becomes a choosable period reading. Internal: the tenant comes
 * from the request.
 *
 * @generated from message mono.datagateway.v1.SetPricingSheetContractStartRequest
 */ export class SetPricingSheetContractStartRequest extends Message {
    static fromBinary(bytes, options) {
        return new SetPricingSheetContractStartRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetPricingSheetContractStartRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetPricingSheetContractStartRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetPricingSheetContractStartRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string generation_id = 2;
   */ _define_property(this, "generationId", ""), /**
   * @generated from field: google.protobuf.Timestamp contract_start = 3;
   */ _define_property(this, "contractStart", void 0), /**
   * @generated from field: string actor = 4;
   */ _define_property(this, "actor", ""), /**
   * Required when a start is already recorded.
   *
   * @generated from field: string reason = 5;
   */ _define_property(this, "reason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetPricingSheetContractStartRequest, "runtime", proto3);
_define_property(SetPricingSheetContractStartRequest, "typeName", "mono.datagateway.v1.SetPricingSheetContractStartRequest");
_define_property(SetPricingSheetContractStartRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "generation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "contract_start",
            kind: "message",
            T: Timestamp
        },
        {
            no: 4,
            name: "actor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SetPricingSheetContractStartResponse
 */ export class SetPricingSheetContractStartResponse extends Message {
    static fromBinary(bytes, options) {
        return new SetPricingSheetContractStartResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetPricingSheetContractStartResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetPricingSheetContractStartResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetPricingSheetContractStartResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.PricingSheetGeneration generation = 1;
   */ _define_property(this, "generation", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetPricingSheetContractStartResponse, "runtime", proto3);
_define_property(SetPricingSheetContractStartResponse, "typeName", "mono.datagateway.v1.SetPricingSheetContractStartResponse");
_define_property(SetPricingSheetContractStartResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "generation",
            kind: "message",
            T: PricingSheetGeneration
        }
    ]));
/**
 * The selected submission is mandatory. Retries use its natural key; a newer
 * submission appends history in the same workspace, preserving the first baseline.
 *
 * @generated from message mono.datagateway.v1.HandoffProposalSubmissionRequest
 */ export class HandoffProposalSubmissionRequest extends Message {
    static fromBinary(bytes, options) {
        return new HandoffProposalSubmissionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new HandoffProposalSubmissionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new HandoffProposalSubmissionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(HandoffProposalSubmissionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string proposal_project_id = 2;
   */ _define_property(this, "proposalProjectId", ""), /**
   * @generated from field: string submission_id = 3;
   */ _define_property(this, "submissionId", ""), /**
   * @generated from field: string actor = 4;
   */ _define_property(this, "actor", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(HandoffProposalSubmissionRequest, "runtime", proto3);
_define_property(HandoffProposalSubmissionRequest, "typeName", "mono.datagateway.v1.HandoffProposalSubmissionRequest");
_define_property(HandoffProposalSubmissionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "proposal_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "submission_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "actor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.HandoffProposalSubmissionResponse
 */ export class HandoffProposalSubmissionResponse extends Message {
    static fromBinary(bytes, options) {
        return new HandoffProposalSubmissionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new HandoffProposalSubmissionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new HandoffProposalSubmissionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(HandoffProposalSubmissionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.PreAwardProject pre_award_project = 1;
   */ _define_property(this, "preAwardProject", void 0), /**
   * @generated from field: mono.datagateway.v1.BidBaseline bid_baseline = 2;
   */ _define_property(this, "bidBaseline", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(HandoffProposalSubmissionResponse, "runtime", proto3);
_define_property(HandoffProposalSubmissionResponse, "typeName", "mono.datagateway.v1.HandoffProposalSubmissionResponse");
_define_property(HandoffProposalSubmissionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "pre_award_project",
            kind: "message",
            T: PreAwardProject
        },
        {
            no: 2,
            name: "bid_baseline",
            kind: "message",
            T: BidBaseline
        }
    ]));
